export type Language = 'es' | 'en' | 'fr' | 'it' | 'pt' | 'de' | 'ar';

const spanish: Record<string, string> = {
  'app.loading': 'Cargando...',
  'app.impersonatingPrefix': 'Impersonalizando a',
  'app.revert': 'Revertir',

  'language.spanish': 'Español',
  'language.english': 'Inglés',
  'language.french': 'Francés',
  'language.italian': 'Italiano',
  'language.portuguese': 'Portugués',
  'language.german': 'Alemán',
  'language.arabic': 'Árabe',
  'language.switchLabel': 'Idioma',
  'language.switchAction': 'Cambiar idioma',
  'language.switchToEnglish': 'Cambiar a inglés',
  'language.switchToSpanish': 'Cambiar a español',
  'language.switchToNext': 'Cambiar a {language}',

  'navigation.tagline': 'Plataforma de Arte',
  'navigation.section.activity': 'Actividad',
  'navigation.section.tools': 'Herramientas',
  'navigation.section.admin': 'Administración',
  'navigation.home': 'Inicio',
  'navigation.explore': 'Explorar',
  'navigation.create': 'Crear',
  'navigation.saved': 'Guardado',
  'navigation.community': 'Comunidad',
  'navigation.profile': 'Perfil',
  'navigation.collaborations': 'Colaboraciones',
  'navigation.messages': 'Mensajes',
  'navigation.events': 'Eventos',
  'navigation.notifications': 'Notificaciones',
  'navigation.analytics': 'Analíticas',
  'navigation.sales': 'Ventas',
  'navigation.help': 'Ayuda',
  'navigation.admin': 'Administración',
  'navigation.ads': 'SoArtistic Ads',
  'navigation.settings': 'Configuración',
  'navigation.logout': 'Cerrar sesión',
  'navigation.menuTitle': 'Menú',
  'navigation.more': 'Más',
  'navigation.myProfile': 'Mi Perfil',
  'navigation.adminRole': 'Administrador',
  'navigation.moderatorRole': 'Moderador',

  'moderation.block.sexual': 'No podemos publicar este contenido porque contiene material sexual explícito.',
  'moderation.block.profanity': 'No podemos publicar este contenido porque incluye lenguaje ofensivo.',
  'moderation.block.generic': 'No podemos publicar este contenido porque infringe las normas de la comunidad.',

  'analytics.error.load': 'Error al cargar las analíticas',
  'analytics.loading.title': 'Cargando analíticas...',
  'analytics.loading.subtitle': 'Estamos preparando tus métricas personalizadas.',
  'analytics.showingData': 'Mostrando datos de',
  'analytics.period.week': 'Última semana',
  'analytics.period.month': 'Último mes',
  'analytics.period.quarter': 'Último trimestre',
  'analytics.period.year': 'Último año',
  'analytics.periodRange.week': 'la última semana',
  'analytics.periodRange.month': 'el último mes',
  'analytics.periodRange.quarter': 'los últimos 3 meses',
  'analytics.periodRange.year': 'el último año',
  'analytics.metric.profileViews': 'Vistas del perfil',
  'analytics.metric.postViews': 'Vistas de publicaciones',
  'analytics.metric.postLikes': 'Likes de publicaciones',
  'analytics.metric.postComments': 'Comentarios de publicaciones',
  'analytics.metric.shares': 'Compartidos',
  'analytics.metric.followers': 'Seguidores',
  'analytics.summary.totalLikes': 'Likes totales',
  'analytics.summary.comments': 'Comentarios',
  'analytics.summary.shares': 'Compartidos',
  'analytics.summary.newFollowers': 'Nuevos seguidores',
  'analytics.summary.engagementRate': 'Tasa de engagement',
  'analytics.topPosts.title': 'Publicaciones con mejor rendimiento',
  'analytics.topPosts.views': 'vistas',
  'analytics.topPosts.likes': 'likes',
  'analytics.topPosts.comments': 'comentarios',
  'analytics.topPosts.engagement': 'engagement',
  'analytics.chart.lastDays': 'Últimos {days} días',
  'analytics.insights.title': 'Insights y recomendaciones',
  'analytics.insights.bestDay': 'Mejor día de la semana',
  'analytics.insights.bestDay.detail': '{day} con {views} vistas',
  'analytics.insights.engagement.title': 'Tasa de engagement',
  'analytics.insights.engagement.excellent': '¡Excelente! Tu contenido genera mucha interacción',
  'analytics.insights.engagement.good': 'Buena tasa de engagement, sigue así',
  'analytics.insights.engagement.tip': 'Intenta crear contenido más interactivo para aumentar el engagement',
  'analytics.insights.growth.title': 'Crecimiento',
  'analytics.insights.growth.positive': '¡Tu alcance creció un {percent}% este período!',
  'analytics.insights.growth.tip': 'Publica con más frecuencia para aumentar tu alcance',
  'analytics.insights.opportunity.title': 'Oportunidad',
  'analytics.insights.opportunity.bio': 'Tus publicaciones atraen más que tu perfil. Optimiza tu biografía.',
  'analytics.insights.opportunity.content': 'Considera crear más contenido para aprovechar el interés en tu perfil.',

  'categories.music': 'Música',
  'categories.writing': 'Escritura',
  'categories.tattoo': 'Tatuajes',
  'categories.digital_design': 'Diseño Digital',
  'categories.fashion_design': 'Diseño de Moda',
  'categories.photography': 'Fotografía',
  'categories.sculpture': 'Escultura',
  'categories.painter': 'Pintura',
  'categories.painting': 'Pintura',
  'categories.dance': 'Danza',
  'categories.filmmaking': 'Cine',
  'categories.makeup': 'Maquillaje',

  'createPost.title': 'Crear Publicación',
  'createPost.error.generic': 'Error al crear la publicación',
  'createPost.error.limit': 'Has alcanzado el límite de 3 publicaciones. Hazte premium para seguir compartiendo tu arte.',
  'createPost.titleLabel': 'Título de la obra',
  'createPost.titlePlaceholder': 'Nombre de tu obra de arte',
  'createPost.categoryLabel': 'Categoría',
  'createPost.categoryPlaceholder': 'Selecciona una categoría',
  'createPost.descriptionLabel': 'Descripción',
  'createPost.descriptionPlaceholder': 'Describe tu obra, técnica utilizada, inspiración...',
  'createPost.coverLabelMusic': 'Portada del álbum/canción',
  'createPost.coverLabelWriting': 'Portada del libro/obra',
  'createPost.coverInvalid': 'La portada debe ser una imagen (JPG, PNG, GIF)',
  'createPost.coverChange': 'Cambiar portada',
  'createPost.coverRemove': 'Quitar',
  'createPost.camera': 'Cámara',
  'createPost.gallery': 'Galería',
  'createPost.coverUpload': 'Haz clic para subir la portada',
  'createPost.coverHint': 'JPG, PNG, GIF (recomendado: 500x500px)',
  'createPost.coverDescriptionMusic': 'La portada representa tu álbum o canción y aparecerá en el reproductor',
  'createPost.coverDescriptionWriting': 'La portada representa tu libro u obra escrita y aparecerá en el lector',
  'createPost.mainFileLabelMusic': 'Archivo principal (audio)',
  'createPost.mainFileLabelWriting': 'Archivo principal (documento)',
  'createPost.mainFileLabelDefault': 'Archivos multimedia',
  'createPost.takePhoto': 'Tomar Foto',
  'createPost.useCamera': 'Usar cámara',
  'createPost.uploadFile': 'Subir Archivo',
  'createPost.fromGallery': 'Desde galería',
  'createPost.desktopUploadMusic': 'Haz clic para subir archivos de audio',
  'createPost.desktopUploadWriting': 'Haz clic para subir documentos',
  'createPost.desktopUploadDefault': 'Haz clic para subir archivos',
  'createPost.desktopUploadTypesDefault': 'Imágenes, videos, audio, PDF, EPUB',
  'createPost.coverPreviewAlt': 'Vista previa de la portada',
  'createPost.tipLabel': 'Consejo',
  'createPost.tipMusic': 'Sube una portada para que tu música se vea más profesional',
  'createPost.tipWriting': 'Sube una portada para que tu obra se vea más profesional',
  'createPost.tagsLabel': 'Tags (separados por comas)',
  'createPost.tagsPlaceholderMusic': 'rock, instrumental, guitarra, melodico',
  'createPost.tagsPlaceholderWriting': 'ficcion, romance, fantasia, novela',
  'createPost.tagsPlaceholderDefault': 'arte, moderno, abstracto, colorido',
  'createPost.forSaleLabel': 'Esta obra está en venta',
  'createPost.priceLabel': 'Precio (EUR)',
  'createPost.pricePlaceholder': '0.00',
  'createPost.cancel': 'Cancelar',
  'createPost.publishing': 'Publicando...',
  'createPost.publish': 'Publicar',

  'auth.validation.emailRequired': 'El email es obligatorio',
  'auth.validation.emailInvalid': 'Email inválido',
  'auth.validation.passwordRequired': 'La contraseña es obligatoria',
  'auth.validation.passwordLength': 'Mínimo 6 caracteres',
  'auth.validation.usernameRequired': 'El usuario es obligatorio',
  'auth.validation.usernameLength': 'Mínimo 3 caracteres',
  'auth.validation.fullNameRequired': 'El nombre es obligatorio',
  'auth.validation.birthDateRequired': 'La fecha de nacimiento es obligatoria',
  'auth.errors.popupBlocked': 'Por favor permite las ventanas emergentes para continuar con la autenticación',
  'auth.errors.userCancelled': 'Autenticación cancelada por el usuario',
  'auth.errors.socialAuthPrefix': 'Error de autenticación con',
  'auth.errors.emailExists': 'Este email ya está registrado. Por favor, inicia sesión o usa otro email.',
  'auth.errors.generic': 'Error de autenticación. Por favor, verifica tus credenciales.',
  'auth.reset.success': 'Se ha enviado un enlace de recuperación a tu email',
  'auth.reset.title': 'Recuperar Contraseña',
  'auth.reset.subtitle': 'Te enviaremos un enlace para restablecer tu contraseña',
  'auth.reset.sending': 'Enviando...',
  'auth.reset.submit': 'Enviar enlace de recuperación',
  'auth.reset.backToLogin': '← Volver al inicio de sesión',
  'auth.reset.error': 'Error al enviar email',
  'auth.emailLabel': 'Dirección de email',
  'auth.emailPlaceholder': 'tu@email.com',
  'auth.hero.tagline': 'La plataforma definitiva donde el arte cobra vida y los artistas se conectan con el mundo',
  'auth.hero.benefit1': 'Conecta con artistas globales',
  'auth.hero.benefit2': 'Vende y compra arte original',
  'auth.hero.benefit3': 'Colabora en proyectos únicos',
  'auth.hero.benefit4': 'Exhibe tu talento al mundo',
  'auth.loginTitle': 'Bienvenido',
  'auth.registerTitle': 'Crear Cuenta',
  'auth.loginSubtitle': 'Accede a tu cuenta de artista',
  'auth.registerSubtitle': 'Únete a la comunidad creativa',
  'auth.social.google': 'Continuar con Google',
  'auth.social.apple': 'Continuar con Apple',
  'auth.social.orEmail': 'o continúa con email',
  'auth.fullNameLabel': 'Nombre completo',
  'auth.fullNamePlaceholder': 'Tu nombre completo',
  'auth.usernameLabel': 'Nombre de usuario',
  'auth.usernamePlaceholder': 'usuario',
  'auth.usernameHint': 'Solo letras, números y guiones bajos. No @ al inicio.',
  'auth.birthDateLabel': 'Fecha de nacimiento',
  'auth.userTypeLabel': 'Tipo de cuenta',
  'auth.userType.visitor': 'Visitante',
  'auth.userType.visitorHelp': 'Explorar y descubrir arte',
  'auth.userType.artist': 'Artista',
  'auth.userType.artistHelp': 'Crear y vender arte',
  'auth.specialtiesLabel': 'Especialidades artísticas',
  'auth.specialtiesHelper': 'Selecciona las categorías que mejor representen tu arte',
  'auth.passwordLabel': 'Contraseña',
  'auth.passwordHint': 'Al menos 6 caracteres',
  'auth.loading.login': 'Iniciando sesión...',
  'auth.loading.register': 'Creando cuenta...',
  'auth.submit.login': 'Iniciar Sesión',
  'auth.submit.register': 'Crear Cuenta',
  'auth.toggle.toRegister': '¿No tienes cuenta? Crear una nueva',
  'auth.toggle.toLogin': '¿Ya tienes cuenta? Iniciar sesión',
  'auth.forgotPasswordLink': '¿Olvidaste tu contraseña?',
  'auth.trust.secureData': 'Datos seguros',
  'auth.trust.ssl': 'SSL encriptado',
  'auth.trust.gdpr': 'GDPR compatible',
  'auth.terms.accept': 'He leído y acepto los',
  'auth.terms.link': 'Términos y Condiciones',

  'auth.didit.title': 'Verificación de mayoría de edad',
  'auth.didit.approved': 'Tu verificación de edad ha sido aprobada. Ya puedes crear tu cuenta.',
  'auth.didit.description': 'Antes de registrarte, completa la verificación de tu edad con Didit usando tu documento de identidad.',
  'auth.didit.status.approved': 'Aprobada',
  'auth.didit.status.declined': 'Rechazada',
  'auth.didit.status.in_review': 'En revisión',
  'auth.didit.status.pending': 'Pendiente',
  'auth.didit.button.repeat': 'Repetir verificación con Didit',
  'auth.didit.button.start': 'Iniciar verificación con Didit',
  'auth.didit.declinedHint': 'Tu verificación ha sido rechazada. Revisa que tu documento sea legible e inténtalo de nuevo.',
  'auth.didit.required': 'Para crear tu cuenta debes completar antes la verificación de edad con Didit.',
  'auth.didit.modalTitle': 'Verificación de identidad',
  'auth.didit.securityTab.description': 'Para cumplir con la normativa y proteger a los usuarios, verificamos que todas las cuentas pertenecen a personas mayores de 18 años mediante documentos oficiales.',
  'auth.didit.statusLabel.verified': 'Estado: verificado',
  'auth.didit.statusLabel.in_review': 'Estado: en revisión',
  'auth.didit.statusLabel.rejected': 'Estado: rechazado',
  'auth.didit.statusLabel.unverified': 'Estado: no verificado',
  'auth.didit.error.loadStatus': 'No se pudo cargar el estado de verificación de edad.',
  'auth.didit.success.documentSent': 'Documento enviado. Revisaremos tu verificación.',
  'auth.didit.error.startVerification': 'Error al iniciar verificación. Inténtalo de nuevo.',
  'auth.didit.error.consentRequired': 'Debes aceptar el consentimiento para continuar.',
  'auth.didit.error.connection': 'Error al conectar con el servidor de verificación. Asegúrate de que el backend está corriendo.',
  'auth.didit.button.manualUpload': 'Subir documento manualmente',
  'auth.didit.button.processing': 'Procesando...',
  'auth.didit.separator.quickVerification': 'O usa verificación rápida',
  'auth.didit.form.documentType': 'Tipo de documento',
  'auth.didit.form.nationalId': 'Documento nacional de identidad',
  'auth.didit.form.passport': 'Pasaporte',
  'auth.didit.form.driverLicense': 'Permiso de conducir',
  'auth.didit.form.issuingCountry': 'País emisor',
  'auth.didit.form.issuingCountryHint': 'Introduce el código ISO de dos letras (ej. ES, FR, DE).',
  'auth.didit.form.last4Digits': 'Últimos 4 dígitos del documento',
  'auth.didit.form.traceabilityHint': 'Usamos esta información para trazabilidad y controles antifraude.',
  'auth.didit.form.birthDate': 'Fecha de nacimiento',
  'auth.didit.form.birthDateHint': 'La fecha de nacimiento se valida también contra el documento.',
  'auth.didit.form.uploadLabel': 'Sube la imagen de tu documento',
  'auth.didit.form.uploadHint': 'Asegúrate de que los datos sean legibles. Se almacenan de forma segura.',
  'auth.didit.form.consent': 'Declaro que la información proporcionada es verídica y autorizo el tratamiento de mis datos para la verificación de mi mayoría de edad según la normativa vigente.',
  'auth.didit.button.connecting': 'Conectando...',
  'auth.didit.button.autoVerify': 'Verificar automáticamente con Didit',
  'auth.didit.info.title': 'Sobre el proceso de verificación:',
  'auth.didit.info.point1': 'En algunos países la verificación se hará automáticamente mediante proveedores especializados o fuentes oficiales.',
  'auth.didit.info.point2': 'En otros casos, nuestro equipo revisará la documentación manualmente.',

  'privacy.export.title': 'Descarga de datos',
  'privacy.export.description': 'Obtén una copia completa de tu actividad, publicaciones y compras en SoArtistic.',
  'privacy.export.button': 'Descargar mis datos',
  'privacy.export.progress': 'Preparando descarga...',
  'privacy.export.success': 'Descarga iniciada. Revisa tu carpeta de descargas.',
  'privacy.export.error': 'No se pudieron descargar tus datos.',
  'privacy.delete.title': 'Eliminar cuenta',
  'privacy.delete.description': 'Esta acción elimina de forma permanente tu cuenta y todos tus datos asociados.',
  'privacy.delete.warning': 'La eliminación es irreversible y cerrarás sesión automáticamente.',
  'privacy.delete.confirmLabel': 'Escribe tu correo para confirmar',
  'privacy.delete.confirmPlaceholder': 'tu@email.com',
  'privacy.delete.button': 'Eliminar definitivamente mi cuenta',
  'privacy.delete.progress': 'Eliminando cuenta...',
  'privacy.delete.success': 'Tu cuenta se eliminó correctamente.',
  'privacy.delete.confirmError': 'Debes introducir tu correo para confirmar la eliminación.',
  'privacy.delete.error': 'No pudimos eliminar tu cuenta.'
};

const english: Record<string, string> = {
  'app.loading': 'Loading...',
  'app.impersonatingPrefix': 'Impersonating',
  'app.revert': 'Revert',

  'language.spanish': 'Spanish',
  'language.english': 'English',
  'language.french': 'French',
  'language.italian': 'Italian',
  'language.portuguese': 'Portuguese',
  'language.german': 'German',
  'language.arabic': 'Arabic',
  'language.switchLabel': 'Language',
  'language.switchAction': 'Change language',
  'language.switchToEnglish': 'Switch to English',
  'language.switchToSpanish': 'Switch to Spanish',
  'language.switchToNext': 'Switch to {language}',

  'navigation.tagline': 'Art Platform',
  'navigation.section.activity': 'Activity',
  'navigation.section.tools': 'Tools',
  'navigation.section.admin': 'Administration',
  'navigation.home': 'Home',
  'navigation.explore': 'Explore',
  'navigation.create': 'Create',
  'navigation.saved': 'Saved',
  'navigation.community': 'Community',
  'navigation.profile': 'Profile',
  'navigation.collaborations': 'Collaborations',
  'navigation.messages': 'Messages',
  'navigation.events': 'Events',
  'navigation.notifications': 'Notifications',
  'navigation.analytics': 'Analytics',
  'navigation.sales': 'Sales',
  'navigation.help': 'Help',
  'navigation.admin': 'Administration',
  'navigation.ads': 'SoArtistic Ads',
  'navigation.settings': 'Settings',
  'navigation.logout': 'Log out',
  'navigation.menuTitle': 'Menu',
  'navigation.more': 'More',
  'navigation.myProfile': 'My Profile',
  'navigation.adminRole': 'Administrator',
  'navigation.moderatorRole': 'Moderator',

  'moderation.block.sexual': 'We can’t publish this content because it contains explicit sexual material.',
  'moderation.block.profanity': 'We can’t publish this content because it includes offensive language.',
  'moderation.block.generic': 'We can’t publish this content because it violates our community guidelines.',

  'analytics.error.load': 'Error loading analytics',
  'analytics.loading.title': 'Loading analytics...',
  'analytics.loading.subtitle': 'We are preparing your personalized metrics.',
  'analytics.showingData': 'Showing data from',
  'analytics.period.week': 'Last week',
  'analytics.period.month': 'Last month',
  'analytics.period.quarter': 'Last quarter',
  'analytics.period.year': 'Last year',
  'analytics.periodRange.week': 'the last week',
  'analytics.periodRange.month': 'the last month',
  'analytics.periodRange.quarter': 'the last 3 months',
  'analytics.periodRange.year': 'the last year',
  'analytics.metric.profileViews': 'Profile views',
  'analytics.metric.postViews': 'Post views',
  'analytics.metric.postLikes': 'Post likes',
  'analytics.metric.postComments': 'Post comments',
  'analytics.metric.shares': 'Shares',
  'analytics.metric.followers': 'Followers',
  'analytics.summary.totalLikes': 'Total likes',
  'analytics.summary.comments': 'Comments',
  'analytics.summary.shares': 'Shares',
  'analytics.summary.newFollowers': 'New followers',
  'analytics.summary.engagementRate': 'Engagement rate',
  'analytics.topPosts.title': 'Top performing posts',
  'analytics.topPosts.views': 'views',
  'analytics.topPosts.likes': 'likes',
  'analytics.topPosts.comments': 'comments',
  'analytics.topPosts.engagement': 'engagement',
  'analytics.chart.lastDays': 'Last {days} days',
  'analytics.insights.title': 'Insights and recommendations',
  'analytics.insights.bestDay': 'Best day of the week',
  'analytics.insights.bestDay.detail': '{day} with {views} views',
  'analytics.insights.engagement.title': 'Engagement rate',
  'analytics.insights.engagement.excellent': 'Excellent! Your content generates a lot of interaction',
  'analytics.insights.engagement.good': 'Good engagement rate, keep it up',
  'analytics.insights.engagement.tip': 'Try creating more interactive content to increase engagement',
  'analytics.insights.growth.title': 'Growth',
  'analytics.insights.growth.positive': 'Your reach grew by {percent}% this period!',
  'analytics.insights.growth.tip': 'Post more often to increase your reach',
  'analytics.insights.opportunity.title': 'Opportunity',
  'analytics.insights.opportunity.bio': 'Your posts attract more than your profile. Optimize your bio.',
  'analytics.insights.opportunity.content': 'Consider creating more content to make the most of interest in your profile.',

  'categories.music': 'Music',
  'categories.writing': 'Writing',
  'categories.tattoo': 'Tattoos',
  'categories.digital_design': 'Digital Design',
  'categories.fashion_design': 'Fashion Design',
  'categories.photography': 'Photography',
  'categories.sculpture': 'Sculpture',
  'categories.painter': 'Painting',
  'categories.painting': 'Painting',
  'categories.dance': 'Dance',
  'categories.filmmaking': 'Filmmaking',
  'categories.makeup': 'Makeup',

  'createPost.title': 'Create Post',
  'createPost.error.generic': 'Error creating the post',
  'createPost.error.limit': 'You reached the 3 post limit. Upgrade to premium to keep sharing your art.',
  'createPost.titleLabel': 'Artwork title',
  'createPost.titlePlaceholder': 'Name your artwork',
  'createPost.categoryLabel': 'Category',
  'createPost.categoryPlaceholder': 'Select a category',
  'createPost.descriptionLabel': 'Description',
  'createPost.descriptionPlaceholder': 'Describe your work, technique, inspiration...',
  'createPost.coverLabelMusic': 'Album/song cover',
  'createPost.coverLabelWriting': 'Book/work cover',
  'createPost.coverInvalid': 'The cover must be an image (JPG, PNG, GIF)',
  'createPost.coverChange': 'Change cover',
  'createPost.coverRemove': 'Remove',
  'createPost.camera': 'Camera',
  'createPost.gallery': 'Gallery',
  'createPost.coverUpload': 'Click to upload the cover',
  'createPost.coverHint': 'JPG, PNG, GIF (recommended: 500x500px)',
  'createPost.coverDescriptionMusic': 'The cover represents your album or song and will appear in the player',
  'createPost.coverDescriptionWriting': 'The cover represents your book or written work and will appear in the reader',
  'createPost.mainFileLabelMusic': 'Main file (audio)',
  'createPost.mainFileLabelWriting': 'Main file (document)',
  'createPost.mainFileLabelDefault': 'Media files',
  'createPost.takePhoto': 'Take photo',
  'createPost.useCamera': 'Use camera',
  'createPost.uploadFile': 'Upload file',
  'createPost.fromGallery': 'From gallery',
  'createPost.desktopUploadMusic': 'Click to upload audio files',
  'createPost.desktopUploadWriting': 'Click to upload documents',
  'createPost.desktopUploadDefault': 'Click to upload files',
  'createPost.desktopUploadTypesDefault': 'Images, videos, audio, PDF, EPUB',
  'createPost.coverPreviewAlt': 'Cover preview',
  'createPost.tipLabel': 'Tip',
  'createPost.tipMusic': 'Add a cover so your music looks more professional',
  'createPost.tipWriting': 'Add a cover so your work looks more professional',
  'createPost.tagsLabel': 'Tags (comma separated)',
  'createPost.tagsPlaceholderMusic': 'rock, instrumental, guitar, melodic',
  'createPost.tagsPlaceholderWriting': 'fiction, romance, fantasy, novel',
  'createPost.tagsPlaceholderDefault': 'art, modern, abstract, colorful',
  'createPost.forSaleLabel': 'This piece is for sale',
  'createPost.priceLabel': 'Price (EUR)',
  'createPost.pricePlaceholder': '0.00',
  'createPost.cancel': 'Cancel',
  'createPost.publishing': 'Publishing...',
  'createPost.publish': 'Publish',

  'auth.validation.emailRequired': 'Email is required',
  'auth.validation.emailInvalid': 'Invalid email',
  'auth.validation.passwordRequired': 'Password is required',
  'auth.validation.passwordLength': 'At least 6 characters',
  'auth.validation.usernameRequired': 'Username is required',
  'auth.validation.usernameLength': 'At least 3 characters',
  'auth.validation.fullNameRequired': 'Full name is required',
  'auth.validation.birthDateRequired': 'Birth date is required',
  'auth.errors.popupBlocked': 'Please allow pop-ups to continue with authentication',
  'auth.errors.userCancelled': 'Authentication cancelled by the user',
  'auth.errors.socialAuthPrefix': 'Authentication error with',
  'auth.errors.emailExists': 'This email is already registered. Please log in or use another email.',
  'auth.errors.generic': 'Authentication error. Please check your credentials.',
  'auth.reset.success': 'We sent a recovery link to your email',
  'auth.reset.title': 'Reset Password',
  'auth.reset.subtitle': 'We will send you a link to reset your password',
  'auth.reset.sending': 'Sending...',
  'auth.reset.submit': 'Send recovery link',
  'auth.reset.backToLogin': '← Back to sign in',
  'auth.reset.error': 'Error sending email',
  'auth.emailLabel': 'Email address',
  'auth.emailPlaceholder': 'you@email.com',
  'auth.hero.tagline': 'The definitive platform where art comes alive and artists connect with the world',
  'auth.hero.benefit1': 'Connect with global artists',
  'auth.hero.benefit2': 'Sell and buy original art',
  'auth.hero.benefit3': 'Collaborate on unique projects',
  'auth.hero.benefit4': 'Showcase your talent to the world',
  'auth.loginTitle': 'Welcome',
  'auth.registerTitle': 'Create Account',
  'auth.loginSubtitle': 'Access your artist account',
  'auth.registerSubtitle': 'Join the creative community',
  'auth.social.google': 'Continue with Google',
  'auth.social.apple': 'Continue with Apple',
  'auth.social.orEmail': 'or continue with email',
  'auth.fullNameLabel': 'Full name',
  'auth.fullNamePlaceholder': 'Your full name',
  'auth.usernameLabel': 'Username',
  'auth.usernamePlaceholder': 'username',
  'auth.usernameHint': 'Only letters, numbers, and underscores. No @ at the start.',
  'auth.birthDateLabel': 'Birth date',
  'auth.userTypeLabel': 'Account type',
  'auth.userType.visitor': 'Visitor',
  'auth.userType.visitorHelp': 'Explore and discover art',
  'auth.userType.artist': 'Artist',
  'auth.userType.artistHelp': 'Create and sell art',
  'auth.specialtiesLabel': 'Art specialties',
  'auth.specialtiesHelper': 'Select the categories that best represent your art',
  'auth.passwordLabel': 'Password',
  'auth.passwordHint': 'At least 6 characters',
  'auth.loading.login': 'Signing in...',
  'auth.loading.register': 'Creating account...',
  'auth.submit.login': 'Sign In',
  'auth.submit.register': 'Create Account',
  'auth.toggle.toRegister': 'Don\'t have an account? Create a new one',
  'auth.toggle.toLogin': 'Already have an account? Sign in',
  'auth.forgotPasswordLink': 'Forgot your password?',
  'auth.trust.secureData': 'Data secured',
  'auth.trust.ssl': 'Encrypted SSL',
  'auth.trust.gdpr': 'GDPR compliant',
  'auth.terms.accept': 'I have read and accept the',
  'auth.terms.link': 'Terms and Conditions',

  'auth.didit.title': 'Age Verification',
  'auth.didit.approved': 'Your age verification has been approved. You can now create your account.',
  'auth.didit.description': 'Before registering, complete your age verification with Didit using your ID document.',
  'auth.didit.status.approved': 'Approved',
  'auth.didit.status.declined': 'Declined',
  'auth.didit.status.in_review': 'In Review',
  'auth.didit.status.pending': 'Pending',
  'auth.didit.button.repeat': 'Retry verification with Didit',
  'auth.didit.button.start': 'Start verification with Didit',
  'auth.didit.declinedHint': 'Your verification was declined. Please ensure your document is legible and try again.',
  'auth.didit.required': 'To create your account, you must first complete the age verification with Didit.',
  'auth.didit.modalTitle': 'Identity Verification',
  'auth.didit.securityTab.description': 'To comply with regulations and protect users, we verify that all accounts belong to people over 18 using official documents.',
  'auth.didit.statusLabel.verified': 'Status: verified',
  'auth.didit.statusLabel.in_review': 'Status: under review',
  'auth.didit.statusLabel.rejected': 'Status: rejected',
  'auth.didit.statusLabel.unverified': 'Status: not verified',
  'auth.didit.error.loadStatus': 'Could not load age verification status.',
  'auth.didit.success.documentSent': 'Document sent. We will review your verification.',
  'auth.didit.error.startVerification': 'Error starting verification. Try again.',
  'auth.didit.error.consentRequired': 'You must accept the consent to continue.',
  'auth.didit.error.connection': 'Error connecting to verification server. Ensure backend is running.',
  'auth.didit.button.manualUpload': 'Upload document manually',
  'auth.didit.button.processing': 'Processing...',
  'auth.didit.separator.quickVerification': 'Or use quick verification',
  'auth.didit.form.documentType': 'Document type',
  'auth.didit.form.nationalId': 'National ID card',
  'auth.didit.form.passport': 'Passport',
  'auth.didit.form.driverLicense': 'Driver license',
  'auth.didit.form.issuingCountry': 'Issuing country',
  'auth.didit.form.issuingCountryHint': 'Enter the two-letter ISO code (e.g. ES, FR, DE).',
  'auth.didit.form.last4Digits': 'Last 4 digits of document',
   'auth.didit.form.traceabilityHint': 'This is used for traceability and anti-fraud checks.',
   'auth.didit.form.birthDate': 'Date of birth',
   'auth.didit.form.birthDateHint': 'The date of birth is also validated against the document.',
   'auth.didit.form.uploadLabel': 'Upload a picture of your document',
   'auth.didit.form.uploadHint': 'Make sure the data is readable. It will be stored securely.',
   'auth.didit.form.consent': 'I declare that the information provided is true and authorize the processing of my data for age verification purposes according to current regulations.',
   'auth.didit.button.connecting': 'Connecting...',
   'auth.didit.button.autoVerify': 'Verify automatically with Didit',
   'auth.didit.info.title': 'About the verification process:',
   'auth.didit.info.point1': 'In some countries verification will be done automatically through specialized providers or official sources.',
   'auth.didit.info.point2': 'In other cases, our team will manually review the documentation.',

  'privacy.export.title': 'Download your data',
  'privacy.export.description': 'Get a complete copy of your activity, posts, and purchases on SoArtistic.',
  'privacy.export.button': 'Download my data',
  'privacy.export.progress': 'Preparing download...',
  'privacy.export.success': 'Download started. Check your downloads folder.',
  'privacy.export.error': 'Unable to download your data.',
  'privacy.delete.title': 'Delete account',
  'privacy.delete.description': 'This action permanently removes your account and all associated data.',
  'privacy.delete.warning': 'Deletion is irreversible and you will be signed out automatically.',
  'privacy.delete.confirmLabel': 'Type your email to confirm',
  'privacy.delete.confirmPlaceholder': 'you@email.com',
  'privacy.delete.button': 'Permanently delete my account',
  'privacy.delete.progress': 'Deleting account...',
  'privacy.delete.success': 'Your account was deleted successfully.',
  'privacy.delete.confirmError': 'Enter your email to confirm deletion.',
  'privacy.delete.error': 'We could not delete your account.'
};

const french: Record<string, string> = {
  'app.loading': 'Chargement...',
  'app.impersonatingPrefix': 'Imitation',
  'app.revert': 'Revenir',
  'language.spanish': 'Espagnol',
  'language.english': 'Anglais',
  'language.french': 'Français',
  'language.italian': 'Italien',
  'language.portuguese': 'Portugais',
  'language.german': 'Allemand',
  'language.arabic': 'Arabe',
  'language.switchLabel': 'Langue',
  'language.switchAction': 'Changer la langue',
  'language.switchToEnglish': 'Passez à l\'anglais',
  'language.switchToSpanish': 'Passer à l\'espagnol',
  'language.switchToNext': 'Passez à {language}',
  'navigation.tagline': 'Plate-forme artistique',
  'navigation.section.activity': 'Activité',
  'navigation.section.tools': 'Outils',
  'navigation.section.admin': 'Administration',
  'navigation.home': 'Accueil',
  'navigation.explore': 'Explorer',
  'navigation.create': 'Créer',
  'navigation.saved': 'Enregistrés',
  'navigation.community': 'Communauté',
  'navigation.profile': 'Profil',
  'navigation.collaborations': 'Collaborations',
  'navigation.messages': 'Messages',
  'navigation.events': 'Événements',
  'navigation.notifications': 'Notifications',
  'navigation.analytics': 'Analyses',
  'navigation.sales': 'Ventes',
  'navigation.help': 'Aide',
  'navigation.admin': 'Administration',
  'navigation.ads': 'Publicités SoArtistic',
  'navigation.settings': 'Paramètres',
  'navigation.logout': 'Se déconnecter',
  'navigation.menuTitle': 'Menu',
  'navigation.more': 'Plus',
  'navigation.myProfile': 'Mon profil',
  'navigation.adminRole': 'Administrateur',
  'navigation.moderatorRole': 'Modérateur',

  'moderation.block.sexual': 'Nous ne pouvons pas publier ce contenu car il contient du contenu sexuel explicite.',
  'moderation.block.profanity': 'Nous ne pouvons pas publier ce contenu car il contient un langage offensant.',
  'moderation.block.generic': 'Nous ne pouvons pas publier ce contenu car il enfreint les règles de la communauté.',

  'analytics.error.load': 'Erreur lors du chargement des analyses',
  'analytics.loading.title': 'Chargement des analyses...',
  'analytics.loading.subtitle': 'Nous préparons vos métriques personnalisées.',
  'analytics.showingData': 'Affichage des données de',
  'analytics.period.week': 'Dernière semaine',
  'analytics.period.month': 'Dernier mois',
  'analytics.period.quarter': 'Dernier trimestre',
  'analytics.period.year': 'Dernière année',
  'analytics.periodRange.week': 'la dernière semaine',
  'analytics.periodRange.month': 'le dernier mois',
  'analytics.periodRange.quarter': 'les 3 derniers mois',
  'analytics.periodRange.year': 'la dernière année',
  'analytics.metric.profileViews': 'Vues du profil',
  'analytics.metric.postViews': 'Vues des publications',
  'analytics.metric.postLikes': 'Mentions J’aime des publications',
  'analytics.metric.postComments': 'Commentaires des publications',
  'analytics.metric.shares': 'Partages',
  'analytics.metric.followers': 'Abonnés',
  'analytics.summary.totalLikes': 'Mentions J’aime totales',
  'analytics.summary.comments': 'Commentaires',
  'analytics.summary.shares': 'Partages',
  'analytics.summary.newFollowers': 'Nouveaux abonnés',
  'analytics.summary.engagementRate': 'Taux d’engagement',
  'analytics.topPosts.title': 'Publications les plus performantes',
  'analytics.topPosts.views': 'vues',
  'analytics.topPosts.likes': 'mentions J’aime',
  'analytics.topPosts.comments': 'commentaires',
  'analytics.topPosts.engagement': 'engagement',
  'analytics.chart.lastDays': 'Derniers {days} jours',
  'analytics.insights.title': 'Analyses et recommandations',
  'analytics.insights.bestDay': 'Meilleur jour de la semaine',
  'analytics.insights.bestDay.detail': '{day} avec {views} vues',
  'analytics.insights.engagement.title': 'Taux d’engagement',
  'analytics.insights.engagement.excellent': 'Excellent ! Votre contenu génère beaucoup d’interactions',
  'analytics.insights.engagement.good': 'Bon taux d’engagement, continuez ainsi',
  'analytics.insights.engagement.tip': 'Essayez de créer un contenu plus interactif pour augmenter l’engagement',
  'analytics.insights.growth.title': 'Croissance',
  'analytics.insights.growth.positive': 'Votre portée a augmenté de {percent}% sur cette période !',
  'analytics.insights.growth.tip': 'Publiez plus souvent pour accroître votre portée',
  'analytics.insights.opportunity.title': 'Opportunité',
  'analytics.insights.opportunity.bio': 'Vos publications attirent plus que votre profil. Optimisez votre bio.',
  'analytics.insights.opportunity.content': 'Envisagez de créer plus de contenu pour profiter de l’intérêt pour votre profil.',
  'categories.music': 'Musique',
  'categories.writing': 'Écriture',
  'categories.tattoo': 'Tatouage',
  'categories.digital_design': 'Design numérique',
  'categories.fashion_design': 'Stylisme',
  'categories.photography': 'Photographie',
  'categories.sculpture': 'Sculpture',
  'categories.painter': 'Peinture',
  'categories.painting': 'Peinture',
  'categories.dance': 'Danse',
  'categories.filmmaking': 'Réalisation',
  'categories.makeup': 'Maquillage',
  'createPost.title': 'Créer un message',
  'createPost.error.generic': 'Erreur lors de la création du message',
  'createPost.error.limit': 'Vous avez atteint la limite de 3 messages. Passez à Premium pour continuer à partager votre art.',
  'createPost.titleLabel': 'Titre de l\'œuvre',
  'createPost.titlePlaceholder': 'Nommez votre œuvre',
  'createPost.categoryLabel': 'Catégorie',
  'createPost.categoryPlaceholder': 'Sélectionnez une catégorie',
  'createPost.descriptionLabel': 'Description',
  'createPost.descriptionPlaceholder': 'Décrivez votre travail, votre technique, votre inspiration...',
  'createPost.coverLabelMusic': 'Couverture de l\'album/chanson',
  'createPost.coverLabelWriting': 'Couverture de livre / travail',
  'createPost.coverInvalid': 'La couverture doit être une image (JPG, PNG, GIF)',
  'createPost.coverChange': 'Changer de couverture',
  'createPost.coverRemove': 'Retirer',
  'createPost.camera': 'Caméra',
  'createPost.gallery': 'Galerie',
  'createPost.coverUpload': 'Cliquez pour télécharger la couverture',
  'createPost.coverHint': 'JPG, PNG, GIF (recommandé : 500x500px)',
  'createPost.coverDescriptionMusic': 'La couverture représente votre album ou votre chanson et apparaîtra dans le lecteur',
  'createPost.coverDescriptionWriting': 'La couverture représente votre livre ou votre travail écrit et apparaîtra dans le lecteur',
  'createPost.mainFileLabelMusic': 'Fichier principal (audio)',
  'createPost.mainFileLabelWriting': 'Fichier principal (document)',
  'createPost.mainFileLabelDefault': 'Fichiers multimédias',
  'createPost.takePhoto': 'Prendre une photo',
  'createPost.useCamera': 'Utiliser la caméra',
  'createPost.uploadFile': 'Télécharger le fichier',
  'createPost.fromGallery': 'De la galerie',
  'createPost.desktopUploadMusic': 'Cliquez pour télécharger des fichiers audio',
  'createPost.desktopUploadWriting': 'Cliquez pour télécharger des documents',
  'createPost.desktopUploadDefault': 'Cliquez pour télécharger des fichiers',
  'createPost.desktopUploadTypesDefault': 'Images, vidéos, audio, pdf, epub',
  'createPost.coverPreviewAlt': 'Couvrir l\'aperçu',
  'createPost.tipLabel': 'Conseil',
  'createPost.tipMusic': 'Ajoutez une couverture pour que votre musique soit plus professionnelle',
  'createPost.tipWriting': 'Ajoutez une couverture pour que votre travail soit plus professionnel',
  'createPost.tagsLabel': 'Balises (séparées par des virgules)',
  'createPost.tagsPlaceholderMusic': 'Rock, instrumental, guitare, mélodique',
  'createPost.tagsPlaceholderWriting': 'fiction, romance, fantaisie, roman',
  'createPost.tagsPlaceholderDefault': 'Art, moderne, abstrait, coloré',
  'createPost.forSaleLabel': 'Cette pièce est à vendre',
  'createPost.priceLabel': 'Prix ​​(EUR)',
  'createPost.pricePlaceholder': '0,00',
  'createPost.cancel': 'Annuler',
  'createPost.publishing': 'Édition...',
  'createPost.publish': 'Publier',
  'auth.validation.emailRequired': 'Un e-mail est requis',
  'auth.validation.emailInvalid': 'E-mail invalide',
  'auth.validation.passwordRequired': 'Le mot de passe est requis',
  'auth.validation.passwordLength': 'Au moins 6 caractères',
  'auth.validation.usernameRequired': 'Le nom d\'utilisateur est requis',
  'auth.validation.usernameLength': 'Au moins 3 caractères',
  'auth.validation.fullNameRequired': 'Le nom complet est requis',
  'auth.validation.birthDateRequired': 'La date de naissance est requise',
  'auth.errors.popupBlocked': 'Veuillez autoriser les fenêtres contextuelles à poursuivre l\'authentification',
  'auth.errors.userCancelled': 'Authentification annulée par l\'utilisateur',
  'auth.errors.socialAuthPrefix': 'Erreur d\'authentification avec',
  'auth.errors.emailExists': 'Cet e-mail est déjà enregistré. Veuillez vous connecter ou utiliser une autre adresse e-mail.',
  'auth.errors.generic': 'Erreur d\'authentification. Veuillez vérifier vos informations d\'identification.',
  'auth.reset.success': 'Nous avons envoyé un lien de récupération vers votre e-mail',
  'auth.reset.title': 'Réinitialiser le mot de passe',
  'auth.reset.subtitle': 'Nous vous enverrons un lien pour réinitialiser votre mot de passe',
  'auth.reset.sending': 'Envoi...',
  'auth.reset.submit': 'Envoyer un lien de récupération',
  'auth.reset.backToLogin': '← Retour pour me connecter',
  'auth.reset.error': 'Erreur d\'envoi e-mail',
  'auth.emailLabel': 'Adresse email',
  'auth.emailPlaceholder': 'vous@email.com',
  'auth.hero.tagline': 'La plate-forme définitive où l\'art prend vie et les artistes se connectent avec le monde',
  'auth.hero.benefit1': 'Connectez-vous avec des artistes du monde entier',
  'auth.hero.benefit2': 'Vendre et acheter de l\'art original',
  'auth.hero.benefit3': 'Collaborez sur des projets uniques',
  'auth.hero.benefit4': 'Présentez votre talent au monde',
  'auth.loginTitle': 'Accueillir',
  'auth.registerTitle': 'Créer un compte',
  'auth.loginSubtitle': 'Accédez à votre compte d\'artiste',
  'auth.registerSubtitle': 'Rejoignez la communauté créative',
  'auth.social.google': 'Continuez avec Google',
  'auth.social.apple': 'Continuer avec Apple',
  'auth.social.orEmail': 'ou continuez avec l\'e-mail',
  'auth.fullNameLabel': 'Nom et prénom',
  'auth.fullNamePlaceholder': 'Votre nom complet',
  'auth.usernameLabel': 'Nom d\'utilisateur',
  'auth.usernamePlaceholder': 'nom d\'utilisateur',
  'auth.usernameHint': 'Seules les lettres, les chiffres et les soulignements. Non @ au début.',
  'auth.birthDateLabel': 'Date de naissance',
  'auth.userTypeLabel': 'Type de compte',
  'auth.userType.visitor': 'Visiteur',
  'auth.userType.visitorHelp': 'Explorez et découvrez de l\'art',
  'auth.userType.artist': 'Artiste',
  'auth.userType.artistHelp': 'Créer et vendre de l\'art',
  'auth.specialtiesLabel': 'Spécialités d\'art',
  'auth.specialtiesHelper': 'Sélectionnez les catégories qui représentent le mieux votre art',
  'auth.passwordLabel': 'Mot de passe',
  'auth.passwordHint': 'Au moins 6 caractères',
  'auth.loading.login': 'Connexion...',
  'auth.loading.register': 'Création du compte...',
  'auth.submit.login': 'Se connecter',
  'auth.submit.register': 'Créer un compte',
  'auth.toggle.toRegister': 'Vous n\'avez pas de compte? En créer un nouveau',
  'auth.toggle.toLogin': 'Vous avez déjà un compte? Se connecter',
  'auth.forgotPasswordLink': 'Vous avez oublié votre mot de passe ?',
  'auth.trust.secureData': 'Données sécurisées',
  'auth.trust.ssl': 'SSL crypté',
  'auth.trust.gdpr': 'Conforme au RGPD',
  'privacy.export.title': 'Téléchargez vos données',
  'privacy.export.description': 'Obtenez une copie complète de votre activité, de vos publications et de vos achats sur SoArtistic.',
  'privacy.export.button': 'Téléchargez mes données',
  'privacy.export.progress': 'Préparer le téléchargement ...',
  'privacy.export.success': 'Le téléchargement a commencé. Vérifiez votre dossier de téléchargements.',
  'privacy.export.error': 'Impossible de télécharger vos données.',
  'privacy.delete.title': 'Supprimer le compte',
  'privacy.delete.description': 'Cette action supprime définitivement votre compte et toutes les données associées.',
  'privacy.delete.warning': 'La suppression est irréversible et vous serez automatiquement déconnecté.',
  'privacy.delete.confirmLabel': 'Tapez votre email pour confirmer',
  'privacy.delete.confirmPlaceholder': 'vous@email.com',
  'privacy.delete.button': 'Supprimer en permanence mon compte',
  'privacy.delete.progress': 'Suppression du compte ...',
  'privacy.delete.success': 'Votre compte a été supprimé avec succès.',
  'privacy.delete.confirmError': 'Entrez votre e-mail pour confirmer la suppression.',
  'privacy.delete.error': 'Nous n\'avons pas pu supprimer votre compte.',
};

const italian: Record<string, string> = {
  'app.loading': 'Caricamento...',
  'app.impersonatingPrefix': 'Impersonare',
  'app.revert': 'Ripristina',
  'language.spanish': 'Spagnolo',
  'language.english': 'Inglese',
  'language.french': 'Francese',
  'language.italian': 'Italiano',
  'language.portuguese': 'Portoghese',
  'language.german': 'Tedesco',
  'language.arabic': 'Arabo',
  'language.switchLabel': 'Lingua',
  'language.switchAction': 'Cambia il linguaggio',
  'language.switchToEnglish': 'Passa all\'inglese',
  'language.switchToSpanish': 'Passa allo spagnolo',
  'language.switchToNext': 'Passa a {language}',
  'navigation.tagline': 'Piattaforma artistica',
  'navigation.section.activity': 'Attività',
  'navigation.section.tools': 'Strumenti',
  'navigation.section.admin': 'Amministrazione',
  'navigation.home': 'Home',
  'navigation.explore': 'Esplorare',
  'navigation.create': 'Creare',
  'navigation.saved': 'Salvati',
  'navigation.community': 'Comunità',
  'navigation.profile': 'Profilo',
  'navigation.collaborations': 'Collaborazioni',
  'navigation.messages': 'Messaggi',
  'navigation.events': 'Eventi',
  'navigation.notifications': 'Notifiche',
  'navigation.analytics': 'Analisi',
  'navigation.sales': 'Vendite',
  'navigation.help': 'Aiuto',
  'navigation.admin': 'Amministrazione',
  'navigation.ads': 'Annunci SoArtistic',
  'navigation.settings': 'Impostazioni',
  'navigation.logout': 'Esci',
  'navigation.menuTitle': 'Menu',
  'navigation.more': 'Di più',
  'navigation.myProfile': 'Il mio profilo',
  'navigation.adminRole': 'Amministratore',
  'navigation.moderatorRole': 'Moderatore',

  'moderation.block.sexual': 'Non possiamo pubblicare questo contenuto perché contiene materiale sessuale esplicito.',
  'moderation.block.profanity': 'Non possiamo pubblicare questo contenuto perché include linguaggio offensivo.',
  'moderation.block.generic': 'Non possiamo pubblicare questo contenuto perché viola le linee guida della community.',

  'analytics.error.load': 'Errore nel caricamento delle analisi',
  'analytics.loading.title': 'Caricamento delle analisi...',
  'analytics.loading.subtitle': 'Stiamo preparando le tue metriche personalizzate.',
  'analytics.showingData': 'Mostrando dati di',
  'analytics.period.week': 'Ultima settimana',
  'analytics.period.month': 'Ultimo mese',
  'analytics.period.quarter': 'Ultimo trimestre',
  'analytics.period.year': 'Ultimo anno',
  'analytics.periodRange.week': 'l\'ultima settimana',
  'analytics.periodRange.month': 'l\'ultimo mese',
  'analytics.periodRange.quarter': 'gli ultimi 3 mesi',
  'analytics.periodRange.year': 'l\'ultimo anno',
  'analytics.metric.profileViews': 'Visualizzazioni del profilo',
  'analytics.metric.postViews': 'Visualizzazioni dei post',
  'analytics.metric.postLikes': 'Mi piace dei post',
  'analytics.metric.postComments': 'Commenti dei post',
  'analytics.metric.shares': 'Condivisioni',
  'analytics.metric.followers': 'Follower',
  'analytics.summary.totalLikes': 'Mi piace totali',
  'analytics.summary.comments': 'Commenti',
  'analytics.summary.shares': 'Condivisioni',
  'analytics.summary.newFollowers': 'Nuovi follower',
  'analytics.summary.engagementRate': 'Tasso di engagement',
  'analytics.topPosts.title': 'Post con le migliori prestazioni',
  'analytics.topPosts.views': 'visualizzazioni',
  'analytics.topPosts.likes': 'mi piace',
  'analytics.topPosts.comments': 'commenti',
  'analytics.topPosts.engagement': 'coinvolgimento',
  'analytics.chart.lastDays': 'Ultimi {days} giorni',
  'analytics.insights.title': 'Insights e raccomandazioni',
  'analytics.insights.bestDay': 'Miglior giorno della settimana',
  'analytics.insights.bestDay.detail': '{day} con {views} visualizzazioni',
  'analytics.insights.engagement.title': 'Tasso di engagement',
  'analytics.insights.engagement.excellent': 'Ottimo! I tuoi contenuti generano molta interazione',
  'analytics.insights.engagement.good': 'Buon tasso di engagement, continua così',
  'analytics.insights.engagement.tip': 'Prova a creare contenuti più interattivi per aumentare l\'engagement',
  'analytics.insights.growth.title': 'Crescita',
  'analytics.insights.growth.positive': 'La tua portata è cresciuta del {percent}% in questo periodo!',
  'analytics.insights.growth.tip': 'Pubblica più spesso per aumentare la tua portata',
  'analytics.insights.opportunity.title': 'Opportunità',
  'analytics.insights.opportunity.bio': 'I tuoi post attirano più attenzione del tuo profilo. Ottimizza la biografia.',
  'analytics.insights.opportunity.content': 'Considera di creare più contenuti per sfruttare l\'interesse per il tuo profilo.',
  'categories.music': 'Musica',
  'categories.writing': 'Scrittura',
  'categories.tattoo': 'Tatuaggi',
  'categories.digital_design': 'Progettazione digitale',
  'categories.fashion_design': 'Progettazione della moda',
  'categories.photography': 'Fotografia',
  'categories.sculpture': 'Scultura',
  'categories.painter': 'Pittura',
  'categories.painting': 'Pittura',
  'categories.dance': 'Danza',
  'categories.filmmaking': 'Produzione cinematografica',
  'categories.makeup': 'Trucco',
  'createPost.title': 'Crea messaggio',
  'createPost.error.generic': 'Errore durante la creazione del post',
  'createPost.error.limit': 'Hai raggiunto il limite di 3 post. Aggiorna a Premium per continuare a condividere la tua arte.',
  'createPost.titleLabel': 'Titolo delle opere d\'arte',
  'createPost.titlePlaceholder': 'Nomina la tua opera d\'arte',
  'createPost.categoryLabel': 'Categoria',
  'createPost.categoryPlaceholder': 'Seleziona una categoria',
  'createPost.descriptionLabel': 'Descrizione',
  'createPost.descriptionPlaceholder': 'Descrivi il tuo lavoro, tecnica, ispirazione ...',
  'createPost.coverLabelMusic': 'Copertina dell\'album/canzone',
  'createPost.coverLabelWriting': 'Libro/copertina di lavoro',
  'createPost.coverInvalid': 'La copertina deve essere un\'immagine (jpg, png, gif)',
  'createPost.coverChange': 'Cambia copertina',
  'createPost.coverRemove': 'Rimuovi',
  'createPost.camera': 'Fotocamera',
  'createPost.gallery': 'Galleria',
  'createPost.coverUpload': 'Fai clic per caricare la copertina',
  'createPost.coverHint': 'JPG, PNG, GIF (consigliato: 500x500px)',
  'createPost.coverDescriptionMusic': 'La copertina rappresenta il tuo album o brano e verrà visualizzata nel lettore',
  'createPost.coverDescriptionWriting': 'La copertina rappresenta il tuo libro o il tuo lavoro scritto e apparirà nel lettore',
  'createPost.mainFileLabelMusic': 'File principale (audio)',
  'createPost.mainFileLabelWriting': 'File principale (documento)',
  'createPost.mainFileLabelDefault': 'File multimediali',
  'createPost.takePhoto': 'Scatta una foto',
  'createPost.useCamera': 'Usa la fotocamera',
  'createPost.uploadFile': 'Carica file',
  'createPost.fromGallery': 'Dalla galleria',
  'createPost.desktopUploadMusic': 'Fare clic per caricare i file audio',
  'createPost.desktopUploadWriting': 'Fare clic per caricare i documenti',
  'createPost.desktopUploadDefault': 'Fare clic per caricare i file',
  'createPost.desktopUploadTypesDefault': 'Immagini, video, audio, PDF, EPUB',
  'createPost.coverPreviewAlt': 'Anteprima della copertina',
  'createPost.tipLabel': 'Mancia',
  'createPost.tipMusic': 'Aggiungi una copertina in modo che la tua musica abbia un aspetto più professionale',
  'createPost.tipWriting': 'Aggiungi una copertina in modo che il tuo lavoro sembri più professionale',
  'createPost.tagsLabel': 'Tag (separati da virgole)',
  'createPost.tagsPlaceholderMusic': 'Rock, strumentale, chitarra, melodico',
  'createPost.tagsPlaceholderWriting': 'narrativa, romanticismo, fantasy, romanzo',
  'createPost.tagsPlaceholderDefault': 'arte, moderna, astratta, colorata',
  'createPost.forSaleLabel': 'Questo pezzo è in vendita',
  'createPost.priceLabel': 'Prezzo (EUR)',
  'createPost.pricePlaceholder': '0,00',
  'createPost.cancel': 'Cancellare',
  'createPost.publishing': 'Publishing ...',
  'createPost.publish': 'Pubblicare',
  'auth.validation.emailRequired': 'L\'e-mail è obbligatoria',
  'auth.validation.emailInvalid': 'Email non valida',
  'auth.validation.passwordRequired': 'È richiesta la password',
  'auth.validation.passwordLength': 'Almeno 6 caratteri',
  'auth.validation.usernameRequired': 'È richiesto il nome utente',
  'auth.validation.usernameLength': 'Almeno 3 caratteri',
  'auth.validation.fullNameRequired': 'È richiesto il nome completo',
  'auth.validation.birthDateRequired': 'La data di nascita è obbligatoria',
  'auth.errors.popupBlocked': 'Si prega di consentire ai pop-up di continuare con l\'autenticazione',
  'auth.errors.userCancelled': 'Autenticazione annullata dall\'utente',
  'auth.errors.socialAuthPrefix': 'Errore di autenticazione con',
  'auth.errors.emailExists': 'Questa email è già registrata. Effettua l\'accesso o utilizza un\'altra email.',
  'auth.errors.generic': 'Errore di autenticazione. Controlla le tue credenziali.',
  'auth.reset.success': 'Abbiamo inviato un collegamento di ripristino alla tua email',
  'auth.reset.title': 'Reimposta password',
  'auth.reset.subtitle': 'Ti invieremo un link per reimpostare la tua password',
  'auth.reset.sending': 'Invio...',
  'auth.reset.submit': 'Invia link di recupero',
  'auth.reset.backToLogin': '← Torna per accedere',
  'auth.reset.error': 'Errore nell\'invio dell\'e-mail',
  'auth.emailLabel': 'Indirizzo e-mail',
  'auth.emailPlaceholder': 'tu@email.com',
  'auth.hero.tagline': 'La piattaforma definitiva in cui l\'arte prende vita e gli artisti si connettono con il mondo',
  'auth.hero.benefit1': 'Connettiti con artisti globali',
  'auth.hero.benefit2': 'Vendi e acquista opere d\'arte originali',
  'auth.hero.benefit3': 'Collaborare a progetti unici',
  'auth.hero.benefit4': 'Mostra il tuo talento nel mondo',
  'auth.loginTitle': 'Benvenuto',
  'auth.registerTitle': 'Creare un account',
  'auth.loginSubtitle': 'Accedi al tuo account artista',
  'auth.registerSubtitle': 'Unisciti alla comunità creativa',
  'auth.social.google': 'Continua con Google',
  'auth.social.apple': 'Continua con Apple',
  'auth.social.orEmail': 'oppure continua con l\'e-mail',
  'auth.fullNameLabel': 'Nome e cognome',
  'auth.fullNamePlaceholder': 'Il tuo nome completo',
  'auth.usernameLabel': 'Nome utente',
  'auth.usernamePlaceholder': 'nome utente',
  'auth.usernameHint': 'Solo lettere, numeri e trattini bassi. No @ all\'inizio.',
  'auth.birthDateLabel': 'Data di nascita',
  'auth.userTypeLabel': 'Tipo di conto',
  'auth.userType.visitor': 'Visitatore',
  'auth.userType.visitorHelp': 'Esplora e scopri l\'arte',
  'auth.userType.artist': 'Artista',
  'auth.userType.artistHelp': 'Crea e vendi arte',
  'auth.specialtiesLabel': 'Specialità artistiche',
  'auth.specialtiesHelper': 'Seleziona le categorie che meglio rappresentano la tua arte',
  'auth.passwordLabel': 'Password',
  'auth.passwordHint': 'Almeno 6 caratteri',
  'auth.loading.login': 'Accesso in corso...',
  'auth.loading.register': 'Creazione dell\'account...',
  'auth.submit.login': 'Registrazione',
  'auth.submit.register': 'Creare un account',
  'auth.toggle.toRegister': 'Non hai un account? Creane uno nuovo',
  'auth.toggle.toLogin': 'Hai già un account? Registrazione',
  'auth.forgotPasswordLink': 'Hai dimenticato la password?',
  'auth.trust.secureData': 'Dati protetti',
  'auth.trust.ssl': 'SSL crittografato',
  'auth.trust.gdpr': 'Conforme al GDPR',
  'privacy.export.title': 'Scarica i tuoi dati',
  'privacy.export.description': 'Ottieni una copia completa della tua attività, dei tuoi post e dei tuoi acquisti su SoArtistic.',
  'privacy.export.button': 'Scarica i miei dati',
  'privacy.export.progress': 'Preparazione download...',
  'privacy.export.success': 'Download avviato. Controlla la cartella dei download.',
  'privacy.export.error': 'Impossibile scaricare i tuoi dati.',
  'privacy.delete.title': 'Elimina account',
  'privacy.delete.description': 'Questa azione rimuove permanentemente il tuo account e tutti i dati associati.',
  'privacy.delete.warning': 'La cancellazione è irreversibile e verrai firmato automaticamente.',
  'privacy.delete.confirmLabel': 'Digita la tua email per confermare',
  'privacy.delete.confirmPlaceholder': 'you@email.com',
  'privacy.delete.button': 'Elimina definitivamente il mio account',
  'privacy.delete.progress': 'Eliminazione account...',
  'privacy.delete.success': 'Il tuo account è stato eliminato con successo.',
  'privacy.delete.confirmError': 'Inserisci la tua email per confermare la cancellazione.',
  'privacy.delete.error': 'Non siamo riusciti a eliminare il tuo account.',
};

const portuguese: Record<string, string> = {
  'app.loading': 'Carregando...',
  'app.impersonatingPrefix': 'Representando',
  'app.revert': 'Reverter',
  'language.spanish': 'Espanhol',
  'language.english': 'Inglês',
  'language.french': 'Francês',
  'language.italian': 'Italiano',
  'language.portuguese': 'Português',
  'language.german': 'Alemão',
  'language.arabic': 'Árabe',
  'language.switchLabel': 'Idioma',
  'language.switchAction': 'Alterar idioma',
  'language.switchToEnglish': 'Mude para o inglês',
  'language.switchToSpanish': 'Mudar para espanhol',
  'language.switchToNext': 'Mude para {language}',
  'navigation.tagline': 'Plataforma de Arte',
  'navigation.section.activity': 'Atividade',
  'navigation.section.tools': 'Ferramentas',
  'navigation.section.admin': 'Administração',
  'navigation.home': 'Início',
  'navigation.explore': 'Explorar',
  'navigation.create': 'Criar',
  'navigation.saved': 'Salvos',
  'navigation.community': 'Comunidade',
  'navigation.profile': 'Perfil',
  'navigation.collaborations': 'Colaborações',
  'navigation.messages': 'Mensagens',
  'navigation.events': 'Eventos',
  'navigation.notifications': 'Notificações',
  'navigation.analytics': 'Análises',
  'navigation.sales': 'Vendas',
  'navigation.help': 'Ajuda',
  'navigation.admin': 'Administração',
  'navigation.ads': 'Anúncios SoArtistic',
  'navigation.settings': 'Configurações',
  'navigation.logout': 'Sair',
  'navigation.menuTitle': 'Menu',
  'navigation.more': 'Mais',
  'navigation.myProfile': 'Meu perfil',
  'navigation.adminRole': 'Administrador',
  'navigation.moderatorRole': 'Moderador',

  'moderation.block.sexual': 'Não podemos publicar este conteúdo porque contém material sexual explícito.',
  'moderation.block.profanity': 'Não podemos publicar este conteúdo porque inclui linguagem ofensiva.',
  'moderation.block.generic': 'Não podemos publicar este conteúdo porque viola as diretrizes da comunidade.',

  'analytics.error.load': 'Erro ao carregar as análises',
  'analytics.loading.title': 'A carregar análises...',
  'analytics.loading.subtitle': 'Estamos a preparar as tuas métricas personalizadas.',
  'analytics.showingData': 'A mostrar dados de',
  'analytics.period.week': 'Última semana',
  'analytics.period.month': 'Último mês',
  'analytics.period.quarter': 'Último trimestre',
  'analytics.period.year': 'Último ano',
  'analytics.periodRange.week': 'a última semana',
  'analytics.periodRange.month': 'o último mês',
  'analytics.periodRange.quarter': 'os últimos 3 meses',
  'analytics.periodRange.year': 'o último ano',
  'analytics.metric.profileViews': 'Visualizações do perfil',
  'analytics.metric.postViews': 'Visualizações das publicações',
  'analytics.metric.postLikes': 'Gostos das publicações',
  'analytics.metric.postComments': 'Comentários das publicações',
  'analytics.metric.shares': 'Partilhas',
  'analytics.metric.followers': 'Seguidores',
  'analytics.summary.totalLikes': 'Gostos totais',
  'analytics.summary.comments': 'Comentários',
  'analytics.summary.shares': 'Partilhas',
  'analytics.summary.newFollowers': 'Novos seguidores',
  'analytics.summary.engagementRate': 'Taxa de engagement',
  'analytics.topPosts.title': 'Publicações com melhor desempenho',
  'analytics.topPosts.views': 'visualizações',
  'analytics.topPosts.likes': 'gostos',
  'analytics.topPosts.comments': 'comentários',
  'analytics.topPosts.engagement': 'engagement',
  'analytics.chart.lastDays': 'Últimos {days} dias',
  'analytics.insights.title': 'Insights e recomendações',
  'analytics.insights.bestDay': 'Melhor dia da semana',
  'analytics.insights.bestDay.detail': '{day} com {views} visualizações',
  'analytics.insights.engagement.title': 'Taxa de engagement',
  'analytics.insights.engagement.excellent': 'Excelente! O teu conteúdo gera muita interação',
  'analytics.insights.engagement.good': 'Boa taxa de engagement, continua assim',
  'analytics.insights.engagement.tip': 'Tenta criar conteúdo mais interativo para aumentar o engagement',
  'analytics.insights.growth.title': 'Crescimento',
  'analytics.insights.growth.positive': 'O teu alcance cresceu {percent}% neste período!',
  'analytics.insights.growth.tip': 'Publica com mais frequência para aumentar o alcance',
  'analytics.insights.opportunity.title': 'Oportunidade',
  'analytics.insights.opportunity.bio': 'As tuas publicações atraem mais do que o teu perfil. Otimiza a tua bio.',
  'analytics.insights.opportunity.content': 'Considera criar mais conteúdo para aproveitar o interesse no teu perfil.',
  'categories.music': 'Música',
  'categories.writing': 'Escrita',
  'categories.tattoo': 'Tatuagens',
  'categories.digital_design': 'Design digital',
  'categories.fashion_design': 'Design de moda',
  'categories.photography': 'Fotografia',
  'categories.sculpture': 'Escultura',
  'categories.painter': 'Pintura',
  'categories.painting': 'Pintura',
  'categories.dance': 'Dança',
  'categories.filmmaking': 'Cinema',
  'categories.makeup': 'Maquiagem',
  'createPost.title': 'Criar postagem',
  'createPost.error.generic': 'Erro ao criar a postagem',
  'createPost.error.limit': 'Você atingiu o limite de 3 postagens. Atualize o Premium para continuar compartilhando sua arte.',
  'createPost.titleLabel': 'Título da obra de arte',
  'createPost.titlePlaceholder': 'Dê um nome à sua arte',
  'createPost.categoryLabel': 'Categoria',
  'createPost.categoryPlaceholder': 'Selecione uma categoria',
  'createPost.descriptionLabel': 'Descrição',
  'createPost.descriptionPlaceholder': 'Descreva seu trabalho, técnica, inspiração ...',
  'createPost.coverLabelMusic': 'Capa do álbum/música',
  'createPost.coverLabelWriting': 'Capa do livro/trabalho',
  'createPost.coverInvalid': 'A capa deve ser uma imagem (JPG, PNG, GIF)',
  'createPost.coverChange': 'Alterar capa',
  'createPost.coverRemove': 'Remover',
  'createPost.camera': 'Câmera',
  'createPost.gallery': 'Galeria',
  'createPost.coverUpload': 'Clique para fazer upload da capa',
  'createPost.coverHint': 'JPG, PNG, GIF (recomendado: 500x500px)',
  'createPost.coverDescriptionMusic': 'A capa representa seu álbum ou música e aparecerá no jogador',
  'createPost.coverDescriptionWriting': 'A capa representa seu livro ou obra escrita e aparecerá no leitor',
  'createPost.mainFileLabelMusic': 'Arquivo principal (áudio)',
  'createPost.mainFileLabelWriting': 'Arquivo principal (documento)',
  'createPost.mainFileLabelDefault': 'Arquivos de mídia',
  'createPost.takePhoto': 'Tire uma foto',
  'createPost.useCamera': 'Use a câmera',
  'createPost.uploadFile': 'Faça o upload do arquivo',
  'createPost.fromGallery': 'Da galeria',
  'createPost.desktopUploadMusic': 'Clique para fazer upload de arquivos de áudio',
  'createPost.desktopUploadWriting': 'Clique para fazer upload de documentos',
  'createPost.desktopUploadDefault': 'Clique para fazer upload de arquivos',
  'createPost.desktopUploadTypesDefault': 'Imagens, vídeos, áudio, pdf, epub',
  'createPost.coverPreviewAlt': 'Visualização da capa',
  'createPost.tipLabel': 'Dica',
  'createPost.tipMusic': 'Adicione uma capa para que sua música pareça mais profissional',
  'createPost.tipWriting': 'Adicione uma capa para que seu trabalho pareça mais profissional',
  'createPost.tagsLabel': 'Tags (separadas por vírgula)',
  'createPost.tagsPlaceholderMusic': 'rock, instrumental, violão, melódico',
  'createPost.tagsPlaceholderWriting': 'ficção, romance, fantasia, romance',
  'createPost.tagsPlaceholderDefault': 'arte, moderna, abstrata, colorida',
  'createPost.forSaleLabel': 'Esta peça está à venda',
  'createPost.priceLabel': 'Preço (EUR)',
  'createPost.pricePlaceholder': '0,00',
  'createPost.cancel': 'Cancelar',
  'createPost.publishing': 'Publicação ...',
  'createPost.publish': 'Publicar',
  'auth.validation.emailRequired': 'O e-mail é obrigatório',
  'auth.validation.emailInvalid': 'Email inválido',
  'auth.validation.passwordRequired': 'A senha é obrigatória',
  'auth.validation.passwordLength': 'Pelo menos 6 caracteres',
  'auth.validation.usernameRequired': 'O nome de usuário é obrigatório',
  'auth.validation.usernameLength': 'Pelo menos 3 caracteres',
  'auth.validation.fullNameRequired': 'O nome completo é obrigatório',
  'auth.validation.birthDateRequired': 'Data de nascimento é necessária',
  'auth.errors.popupBlocked': 'Permita que os pop-ups continuem com a autenticação',
  'auth.errors.userCancelled': 'Autenticação cancelada pelo usuário',
  'auth.errors.socialAuthPrefix': 'Erro de autenticação com',
  'auth.errors.emailExists': 'Este e-mail já está registado. Faça login ou use outro e-mail.',
  'auth.errors.generic': 'Erro de autenticação. Por favor, verifique suas credenciais.',
  'auth.reset.success': 'Enviamos um link de recuperação para seu e-mail',
  'auth.reset.title': 'Redefinir senha',
  'auth.reset.subtitle': 'Enviaremos um link para redefinir sua senha',
  'auth.reset.sending': 'Enviando...',
  'auth.reset.submit': 'Enviar link de recuperação',
  'auth.reset.backToLogin': '← Voltar para entrar',
  'auth.reset.error': 'Erro ao enviar e-mail',
  'auth.emailLabel': 'Endereço de email',
  'auth.emailPlaceholder': 'você@email.com',
  'auth.hero.tagline': 'A plataforma definitiva onde a arte ganha vida e os artistas se conectam com o mundo',
  'auth.hero.benefit1': 'Conecte-se com artistas globais',
  'auth.hero.benefit2': 'Vender e comprar arte original',
  'auth.hero.benefit3': 'Colaborar em projetos únicos',
  'auth.hero.benefit4': 'Mostre seu talento para o mundo',
  'auth.loginTitle': 'Bem-vindo',
  'auth.registerTitle': 'Criar uma conta',
  'auth.loginSubtitle': 'Acesse sua conta de artista',
  'auth.registerSubtitle': 'Junte -se à comunidade criativa',
  'auth.social.google': 'Continue com o Google',
  'auth.social.apple': 'Continue com a Apple',
  'auth.social.orEmail': 'ou continue com e -mail',
  'auth.fullNameLabel': 'Nome completo',
  'auth.fullNamePlaceholder': 'Seu nome completo',
  'auth.usernameLabel': 'Nome de usuário',
  'auth.usernamePlaceholder': 'nome de usuário',
  'auth.usernameHint': 'Apenas letras, números e sublinhados. Não @ no início.',
  'auth.birthDateLabel': 'Data de nascimento',
  'auth.userTypeLabel': 'Tipo de conta',
  'auth.userType.visitor': 'Visitante',
  'auth.userType.visitorHelp': 'Explore e descubra arte',
  'auth.userType.artist': 'Artista',
  'auth.userType.artistHelp': 'Criar e vender arte',
  'auth.specialtiesLabel': 'Especialidades artísticas',
  'auth.specialtiesHelper': 'Selecione as categorias que melhor representam sua arte',
  'auth.passwordLabel': 'Senha',
  'auth.passwordHint': 'Pelo menos 6 caracteres',
  'auth.loading.login': 'Fazendo login...',
  'auth.loading.register': 'Criando conta...',
  'auth.submit.login': 'Entrar',
  'auth.submit.register': 'Criar uma conta',
  'auth.toggle.toRegister': 'Não tem uma conta? Criar um novo',
  'auth.toggle.toLogin': 'Já tem uma conta? Entrar',
  'auth.forgotPasswordLink': 'Esqueceu sua senha?',
  'auth.trust.secureData': 'Dados garantidos',
  'auth.trust.ssl': 'SSL criptografado',
  'auth.trust.gdpr': 'Compatível com GDPR',
  'privacy.export.title': 'Baixe seus dados',
  'privacy.export.description': 'Obtenha uma cópia completa de suas atividades, postagens e compras no SoArtistic.',
  'privacy.export.button': 'Baixar meus dados',
  'privacy.export.progress': 'Preparando download ...',
  'privacy.export.success': 'Download iniciado. Verifique sua pasta de downloads.',
  'privacy.export.error': 'Não foi possível baixar seus dados.',
  'privacy.delete.title': 'Excluir conta',
  'privacy.delete.description': 'Essa ação remove permanentemente sua conta e todos os dados associados.',
  'privacy.delete.warning': 'A exclusão é irreversível e você será desconectado automaticamente.',
  'privacy.delete.confirmLabel': 'Digite seu e -mail para confirmar',
  'privacy.delete.confirmPlaceholder': 'você@email.com',
  'privacy.delete.button': 'Exclua permanentemente minha conta',
  'privacy.delete.progress': 'Excluindo a conta ...',
  'privacy.delete.success': 'Sua conta foi excluída com sucesso.',
  'privacy.delete.confirmError': 'Digite seu e -mail para confirmar a exclusão.',
  'privacy.delete.error': 'Não conseguimos excluir sua conta.',
};

const german: Record<string, string> = {
  'app.loading': 'Laden...',
  'app.impersonatingPrefix': 'Imitieren',
  'app.revert': 'Zurücksetzen',
  'language.spanish': 'Spanisch',
  'language.english': 'Englisch',
  'language.french': 'Französisch',
  'language.italian': 'Italienisch',
  'language.portuguese': 'Portugiesisch',
  'language.german': 'Deutsch',
  'language.arabic': 'Arabisch',
  'language.switchLabel': 'Sprache',
  'language.switchAction': 'Sprache ändern',
  'language.switchToEnglish': 'Wechseln Sie zu Englisch',
  'language.switchToSpanish': 'Wechseln Sie zu Spanisch',
  'language.switchToNext': 'Wechseln Sie zu {language}',
  'navigation.tagline': 'Kunstplattform',
  'navigation.section.activity': 'Aktivität',
  'navigation.section.tools': 'Werkzeuge',
  'navigation.section.admin': 'Verwaltung',
  'navigation.home': 'Startseite',
  'navigation.explore': 'Erkunden',
  'navigation.create': 'Erstellen',
  'navigation.saved': 'Gespeichert',
  'navigation.community': 'Gemeinschaft',
  'navigation.profile': 'Profil',
  'navigation.collaborations': 'Zusammenarbeit',
  'navigation.messages': 'Nachrichten',
  'navigation.events': 'Ereignisse',
  'navigation.notifications': 'Benachrichtigungen',
  'navigation.analytics': 'Analysen',
  'navigation.sales': 'Verkäufe',
  'navigation.help': 'Hilfe',
  'navigation.admin': 'Verwaltung',
  'navigation.ads': 'SoArtistic Ads',
  'navigation.settings': 'Einstellungen',
  'navigation.logout': 'Abmelden',
  'navigation.menuTitle': 'Menü',
  'navigation.more': 'Mehr',
  'navigation.myProfile': 'Mein Profil',
  'navigation.adminRole': 'Administrator',
  'navigation.moderatorRole': 'Moderator',

  'moderation.block.sexual': 'Wir können diesen Inhalt nicht veröffentlichen, da er explizites sexuelles Material enthält.',
  'moderation.block.profanity': 'Wir können diesen Inhalt nicht veröffentlichen, da er beleidigende Sprache enthält.',
  'moderation.block.generic': 'Wir können diesen Inhalt nicht veröffentlichen, da er gegen unsere Community-Richtlinien verstößt.',

  'analytics.error.load': 'Fehler beim Laden der Analysen',
  'analytics.loading.title': 'Analysen werden geladen...',
  'analytics.loading.subtitle': 'Wir bereiten deine personalisierten Kennzahlen vor.',
  'analytics.showingData': 'Daten aus',
  'analytics.period.week': 'Letzte Woche',
  'analytics.period.month': 'Letzter Monat',
  'analytics.period.quarter': 'Letztes Quartal',
  'analytics.period.year': 'Letztes Jahr',
  'analytics.periodRange.week': 'der letzten Woche',
  'analytics.periodRange.month': 'des letzten Monats',
  'analytics.periodRange.quarter': 'der letzten 3 Monate',
  'analytics.periodRange.year': 'des letzten Jahres',
  'analytics.metric.profileViews': 'Profilaufrufe',
  'analytics.metric.postViews': 'Beitragsaufrufe',
  'analytics.metric.postLikes': 'Beitrags-Likes',
  'analytics.metric.postComments': 'Beitrags-Kommentare',
  'analytics.metric.shares': 'Freigaben',
  'analytics.metric.followers': 'Follower',
  'analytics.summary.totalLikes': 'Likes insgesamt',
  'analytics.summary.comments': 'Kommentare',
  'analytics.summary.shares': 'Freigaben',
  'analytics.summary.newFollowers': 'Neue Follower',
  'analytics.summary.engagementRate': 'Engagement-Rate',
  'analytics.topPosts.title': 'Leistungsstärkste Beiträge',
  'analytics.topPosts.views': 'Aufrufe',
  'analytics.topPosts.likes': 'Likes',
  'analytics.topPosts.comments': 'Kommentare',
  'analytics.topPosts.engagement': 'Engagement',
  'analytics.chart.lastDays': 'Letzte {days} Tage',
  'analytics.insights.title': 'Einblicke und Empfehlungen',
  'analytics.insights.bestDay': 'Bester Wochentag',
  'analytics.insights.bestDay.detail': '{day} mit {views} Aufrufen',
  'analytics.insights.engagement.title': 'Engagement-Rate',
  'analytics.insights.engagement.excellent': 'Ausgezeichnet! Deine Inhalte sorgen für viel Interaktion',
  'analytics.insights.engagement.good': 'Gute Engagement-Rate, weiter so',
  'analytics.insights.engagement.tip': 'Erstelle interaktivere Inhalte, um das Engagement zu steigern',
  'analytics.insights.growth.title': 'Wachstum',
  'analytics.insights.growth.positive': 'Deine Reichweite ist in diesem Zeitraum um {percent}% gestiegen!',
  'analytics.insights.growth.tip': 'Veröffentliche häufiger, um deine Reichweite zu erhöhen',
  'analytics.insights.opportunity.title': 'Chance',
  'analytics.insights.opportunity.bio': 'Deine Beiträge ziehen mehr Aufmerksamkeit an als dein Profil. Optimiere deine Bio.',
  'analytics.insights.opportunity.content': 'Erstelle mehr Inhalte, um das Interesse an deinem Profil zu nutzen.',
  'categories.music': 'Musik',
  'categories.writing': 'Schreiben',
  'categories.tattoo': 'Tattoos',
  'categories.digital_design': 'Digitales Design',
  'categories.fashion_design': 'Modedesign',
  'categories.photography': 'Fotografie',
  'categories.sculpture': 'Skulptur',
  'categories.painter': 'Malerei',
  'categories.painting': 'Malerei',
  'categories.dance': 'Tanz',
  'categories.filmmaking': 'Filmemachen',
  'categories.makeup': 'Make-up',
  'createPost.title': 'Post erstellen',
  'createPost.error.generic': 'Fehler beim Erstellen des Beitrags',
  'createPost.error.limit': 'Sie haben das Limit von 3 Beiträgen erreicht. Upgraden Sie auf Premium, um Ihre Kunst weiterhin zu teilen.',
  'createPost.titleLabel': 'Artworktitel',
  'createPost.titlePlaceholder': 'Benennen Sie Ihr Kunstwerk',
  'createPost.categoryLabel': 'Kategorie',
  'createPost.categoryPlaceholder': 'Wählen Sie eine Kategorie aus',
  'createPost.descriptionLabel': 'Beschreibung',
  'createPost.descriptionPlaceholder': 'Beschreiben Sie Ihre Arbeit, Ihre Technik, Ihre Inspiration ...',
  'createPost.coverLabelMusic': 'Album/Song -Cover',
  'createPost.coverLabelWriting': 'Buch-/Arbeitseinband',
  'createPost.coverInvalid': 'Das Cover muss ein Bild sein (JPG, PNG, GIF)',
  'createPost.coverChange': 'Cover ändern',
  'createPost.coverRemove': 'Entfernen',
  'createPost.camera': 'Kamera',
  'createPost.gallery': 'Galerie',
  'createPost.coverUpload': 'Klicken Sie, um das Cover hochzuladen',
  'createPost.coverHint': 'JPG, PNG, GIF (empfohlen: 500x500px)',
  'createPost.coverDescriptionMusic': 'Das Cover repräsentiert Ihr Album oder Lied und wird im Spieler erscheinen',
  'createPost.coverDescriptionWriting': 'Das Cover repräsentiert Ihr Buch oder Ihre schriftliche Arbeit und erscheint im Reader',
  'createPost.mainFileLabelMusic': 'Hauptdatei (Audio)',
  'createPost.mainFileLabelWriting': 'Hauptdatei (Dokument)',
  'createPost.mainFileLabelDefault': 'Mediendateien',
  'createPost.takePhoto': 'Foto aufnehmen',
  'createPost.useCamera': 'Kamera verwenden',
  'createPost.uploadFile': 'Datei hochladen',
  'createPost.fromGallery': 'Aus der Galerie',
  'createPost.desktopUploadMusic': 'Klicken Sie hier, um Audiodateien hochzuladen',
  'createPost.desktopUploadWriting': 'Klicken Sie hier, um Dokumente hochzuladen',
  'createPost.desktopUploadDefault': 'Klicken Sie hier, um Dateien hochzuladen',
  'createPost.desktopUploadTypesDefault': 'Bilder, Videos, Audio, PDF, EPUB',
  'createPost.coverPreviewAlt': 'Cover-Vorschau',
  'createPost.tipLabel': 'Tipp',
  'createPost.tipMusic': 'Fügen Sie ein Cover hinzu, damit Ihre Musik professioneller aussieht',
  'createPost.tipWriting': 'Fügen Sie ein Cover hinzu, damit Ihre Arbeit professioneller aussieht',
  'createPost.tagsLabel': 'Tags (durch Kommas getrennt)',
  'createPost.tagsPlaceholderMusic': 'Rock, Instrumental, Gitarre, melodisch',
  'createPost.tagsPlaceholderWriting': 'Fiktion, Romantik, Fantasy, Roman',
  'createPost.tagsPlaceholderDefault': 'Kunst, modern, abstrakt, farbenfroh',
  'createPost.forSaleLabel': 'Dieses Stück steht zum Verkauf',
  'createPost.priceLabel': 'Preis (EUR)',
  'createPost.pricePlaceholder': '0,00',
  'createPost.cancel': 'Stornieren',
  'createPost.publishing': 'Veröffentlichung ...',
  'createPost.publish': 'Veröffentlichen',
  'auth.validation.emailRequired': 'E -Mail ist erforderlich',
  'auth.validation.emailInvalid': 'Ungültige E-Mail',
  'auth.validation.passwordRequired': 'Passwort ist erforderlich',
  'auth.validation.passwordLength': 'Mindestens 6 Zeichen',
  'auth.validation.usernameRequired': 'Benutzername ist erforderlich',
  'auth.validation.usernameLength': 'Mindestens 3 Zeichen',
  'auth.validation.fullNameRequired': 'Der vollständige Name ist erforderlich',
  'auth.validation.birthDateRequired': 'Geburtsdatum ist erforderlich',
  'auth.errors.popupBlocked': 'Bitte lassen Sie zu, dass Popups mit der Authentifizierung fortfahren',
  'auth.errors.userCancelled': 'Authentifizierung vom Benutzer abgebrochen',
  'auth.errors.socialAuthPrefix': 'Authentifizierungsfehler mit',
  'auth.errors.emailExists': 'Diese E-Mail ist bereits registriert. Bitte melden Sie sich an oder verwenden Sie eine andere E-Mail-Adresse.',
  'auth.errors.generic': 'Authentifizierungsfehler. Bitte überprüfen Sie Ihre Anmeldeinformationen.',
  'auth.reset.success': 'Wir haben einen Wiederherstellungslink an Ihre E-Mail-Adresse gesendet',
  'auth.reset.title': 'Passwort zurücksetzen',
  'auth.reset.subtitle': 'Wir senden Ihnen einen Link, um Ihr Passwort zurückzusetzen',
  'auth.reset.sending': 'Senden...',
  'auth.reset.submit': 'Wiederherstellungslink senden',
  'auth.reset.backToLogin': '← Zurück, um sich anzumelden',
  'auth.reset.error': 'Fehler beim Senden der E-Mail',
  'auth.emailLabel': 'E-Mail-Adresse',
  'auth.emailPlaceholder': 'you@email.com',
  'auth.hero.tagline': 'Die endgültige Plattform, auf der Kunst lebendig wird, und Künstler verbinden sich mit der Welt',
  'auth.hero.benefit1': 'Verbinden Sie sich mit globalen Künstlern',
  'auth.hero.benefit2': 'Verkaufen und kaufen Sie Originalkunst',
  'auth.hero.benefit3': 'Arbeiten Sie an einzigartigen Projekten mit',
  'auth.hero.benefit4': 'Präsentieren Sie der Welt Ihr Talent',
  'auth.loginTitle': 'Willkommen',
  'auth.registerTitle': 'Benutzerkonto erstellen',
  'auth.loginSubtitle': 'Greifen Sie auf Ihr Künstlerkonto zu',
  'auth.registerSubtitle': 'Treten Sie der kreativen Gemeinschaft bei',
  'auth.social.google': 'Fahren Sie mit Google fort',
  'auth.social.apple': 'Fahren Sie mit Apple fort',
  'auth.social.orEmail': 'oder fahren Sie mit E -Mail fort',
  'auth.fullNameLabel': 'Vollständiger Name',
  'auth.fullNamePlaceholder': 'Ihr vollständiger Name',
  'auth.usernameLabel': 'Benutzername',
  'auth.usernamePlaceholder': 'Benutzername',
  'auth.usernameHint': 'Nur Buchstaben, Zahlen und Unterstriche. Kein @ am Anfang.',
  'auth.birthDateLabel': 'Geburtsdatum',
  'auth.userTypeLabel': 'Kontotyp',
  'auth.userType.visitor': 'Gast',
  'auth.userType.visitorHelp': 'Entdecken und entdecken Sie Kunst',
  'auth.userType.artist': 'Künstler',
  'auth.userType.artistHelp': 'Kunst schaffen und verkaufen',
  'auth.specialtiesLabel': 'Kunstspezialitäten',
  'auth.specialtiesHelper': 'Wählen Sie die Kategorien aus, die Ihre Kunst am besten darstellen',
  'auth.passwordLabel': 'Passwort',
  'auth.passwordHint': 'Mindestens 6 Zeichen',
  'auth.loading.login': 'Anmeldung...',
  'auth.loading.register': 'Konto wird erstellt...',
  'auth.submit.login': 'Anmelden',
  'auth.submit.register': 'Benutzerkonto erstellen',
  'auth.toggle.toRegister': 'Sie haben kein Konto? Erstellen Sie eine neue',
  'auth.toggle.toLogin': 'Haben Sie bereits ein Konto? anmelden',
  'auth.forgotPasswordLink': 'Ihr Passwort vergessen?',
  'auth.trust.secureData': 'Daten gesichert',
  'auth.trust.ssl': 'Verschlüsseltes SSL',
  'auth.trust.gdpr': 'DSGVO-konform',
  'privacy.export.title': 'Laden Sie Ihre Daten herunter',
  'privacy.export.description': 'Erhalten Sie eine vollständige Kopie Ihrer Aktivitäten, Beiträge und Einkäufe auf SoArtistic.',
  'privacy.export.button': 'Laden Sie meine Daten herunter',
  'privacy.export.progress': 'Download wird vorbereitet...',
  'privacy.export.success': 'Download gestartet. Überprüfen Sie Ihren Download-Ordner.',
  'privacy.export.error': 'Ihre Daten können nicht heruntergeladen werden.',
  'privacy.delete.title': 'Konto löschen',
  'privacy.delete.description': 'Diese Aktion beseitigt Ihr Konto und alle zugehörigen Daten dauerhaft.',
  'privacy.delete.warning': 'Die Löschung ist unwiderruflich und Sie werden automatisch abgemeldet.',
  'privacy.delete.confirmLabel': 'Geben Sie Ihre E -Mail ein, um dies zu bestätigen',
  'privacy.delete.confirmPlaceholder': 'you@email.com',
  'privacy.delete.button': 'Mein Konto dauerhaft löschen',
  'privacy.delete.progress': 'Konto löschen ...',
  'privacy.delete.success': 'Ihr Konto wurde erfolgreich gelöscht.',
  'privacy.delete.confirmError': 'Geben Sie Ihre E-Mail-Adresse ein, um den Löschvorgang zu bestätigen.',
  'privacy.delete.error': 'Wir konnten Ihr Konto nicht löschen.',
};

const arabic: Record<string, string> = {
  'app.loading': 'تحميل...',
  'app.impersonatingPrefix': 'انتحال شخصية',
  'app.revert': 'يرجع',
  'language.spanish': 'الأسبانية',
  'language.english': 'إنجليزي',
  'language.french': 'فرنسي',
  'language.italian': 'إيطالي',
  'language.portuguese': 'البرتغالية',
  'language.german': 'الألمانية',
  'language.arabic': 'العربية',
  'language.switchLabel': 'اللغة',
  'language.switchAction': 'تغيير اللغة',
  'language.switchToEnglish': 'التبديل إلى اللغة الإنجليزية',
  'language.switchToSpanish': 'التبديل إلى الإسبانية',
  'language.switchToNext': 'قم بالتبديل إلى {language}',
  'navigation.tagline': 'منصة الفن',
  'navigation.section.activity': 'نشاط',
  'navigation.section.tools': 'أدوات',
  'navigation.section.admin': 'إدارة',
  'navigation.home': 'الرئيسية',
  'navigation.explore': 'يستكشف',
  'navigation.create': 'يخلق',
  'navigation.saved': 'المحفوظات',
  'navigation.community': 'المجتمع',
  'navigation.profile': 'الملف الشخصي',
  'navigation.collaborations': 'التعاونات',
  'navigation.messages': 'الرسائل',
  'navigation.events': 'الأحداث',
  'navigation.notifications': 'إشعارات',
  'navigation.analytics': 'التحليلات',
  'navigation.sales': 'مبيعات',
  'navigation.help': 'المساعدة',
  'navigation.admin': 'إدارة',
  'navigation.ads': 'إعلانات SoArtistic',
  'navigation.settings': 'إعدادات',
  'navigation.logout': 'تسجيل الخروج',
  'navigation.menuTitle': 'القائمة',
  'navigation.more': 'أكثر',
  'navigation.myProfile': 'ملفي الشخصي',
  'navigation.adminRole': 'المسؤول',
  'navigation.moderatorRole': 'مشرف',

  'moderation.block.sexual': 'لا يمكننا نشر هذا المحتوى لأنه يحتوي على مواد جنسية صريحة.',
  'moderation.block.profanity': 'لا يمكننا نشر هذا المحتوى لأنه يتضمن لغة مسيئة.',
  'moderation.block.generic': 'لا يمكننا نشر هذا المحتوى لأنه يخالف إرشادات المجتمع.',

  'analytics.error.load': 'حدث خطأ أثناء تحميل التحليلات',
  'analytics.loading.title': 'جارٍ تحميل التحليلات...',
  'analytics.loading.subtitle': 'نقوم بإعداد مؤشراتك المخصصة.',
  'analytics.showingData': 'يتم عرض البيانات من',
  'analytics.period.week': 'آخر أسبوع',
  'analytics.period.month': 'آخر شهر',
  'analytics.period.quarter': 'آخر ثلاثة أشهر',
  'analytics.period.year': 'آخر سنة',
  'analytics.periodRange.week': 'الأسبوع الأخير',
  'analytics.periodRange.month': 'الشهر الأخير',
  'analytics.periodRange.quarter': 'آخر 3 أشهر',
  'analytics.periodRange.year': 'السنة الأخيرة',
  'analytics.metric.profileViews': 'مشاهدات الملف الشخصي',
  'analytics.metric.postViews': 'مشاهدات المنشورات',
  'analytics.metric.postLikes': 'إعجابات المنشورات',
  'analytics.metric.postComments': 'تعليقات المنشورات',
  'analytics.metric.shares': 'المشاركات',
  'analytics.metric.followers': 'المتابعون',
  'analytics.summary.totalLikes': 'إجمالي الإعجابات',
  'analytics.summary.comments': 'التعليقات',
  'analytics.summary.shares': 'المشاركات',
  'analytics.summary.newFollowers': 'المتابعون الجدد',
  'analytics.summary.engagementRate': 'معدل التفاعل',
  'analytics.topPosts.title': 'أفضل المنشورات أداءً',
  'analytics.topPosts.views': 'مشاهدات',
  'analytics.topPosts.likes': 'إعجابات',
  'analytics.topPosts.comments': 'تعليقات',
  'analytics.topPosts.engagement': 'تفاعل',
  'analytics.chart.lastDays': 'آخر {days} يومًا',
  'analytics.insights.title': 'إحصاءات وتوصيات',
  'analytics.insights.bestDay': 'أفضل يوم في الأسبوع',
  'analytics.insights.bestDay.detail': '{day} مع {views} مشاهدة',
  'analytics.insights.engagement.title': 'معدل التفاعل',
  'analytics.insights.engagement.excellent': 'رائع! ينشئ محتواك تفاعلًا كبيرًا',
  'analytics.insights.engagement.good': 'معدل تفاعل جيد، استمر على هذا المنوال',
  'analytics.insights.engagement.tip': 'حاول إنشاء محتوى أكثر تفاعلًا لزيادة معدل التفاعل',
  'analytics.insights.growth.title': 'النمو',
  'analytics.insights.growth.positive': 'نطاق وصولك زاد بنسبة {percent}% خلال هذه الفترة!',
  'analytics.insights.growth.tip': 'انشر بمعدل أكبر لزيادة نطاق الوصول',
  'analytics.insights.opportunity.title': 'فرصة',
  'analytics.insights.opportunity.bio': 'منشوراتك تجذب أكثر من ملفك الشخصي. حسّن سيرتك الذاتية.',
  'analytics.insights.opportunity.content': 'فكر في إنشاء المزيد من المحتوى للاستفادة من الاهتمام بملفك الشخصي.',
  'categories.music': 'موسيقى',
  'categories.writing': 'كتابة',
  'categories.tattoo': 'الوشم',
  'categories.digital_design': 'التصميم الرقمي',
  'categories.fashion_design': 'تصميم الأزياء',
  'categories.photography': 'التصوير الفوتوغرافي',
  'categories.sculpture': 'النحت',
  'categories.painter': 'الرسم',
  'categories.painting': 'الرسم',
  'categories.dance': 'الرقص',
  'categories.filmmaking': 'صناعة الأفلام',
  'categories.makeup': 'ماكياج',
  'createPost.title': 'إنشاء منشور',
  'createPost.error.generic': 'خطأ في إنشاء المنشور',
  'createPost.error.limit': 'وصلت إلى حد ما 3 post. ترقية إلى Premium لمواصلة مشاركة فنك.',
  'createPost.titleLabel': 'عنوان العمل الفني',
  'createPost.titlePlaceholder': 'اسم عملك الفني',
  'createPost.categoryLabel': 'فئة',
  'createPost.categoryPlaceholder': 'حدد فئة',
  'createPost.descriptionLabel': 'وصف',
  'createPost.descriptionPlaceholder': 'قم بوصف عملك، وتقنياتك، وإلهامك...',
  'createPost.coverLabelMusic': 'غلاف الألبوم/الأغنية',
  'createPost.coverLabelWriting': 'غلاف الكتاب/العمل',
  'createPost.coverInvalid': 'يجب أن يكون الغلاف صورة (JPG، PNG، GIF)',
  'createPost.coverChange': 'تغيير الغلاف',
  'createPost.coverRemove': 'إزالة',
  'createPost.camera': 'آلة تصوير',
  'createPost.gallery': 'معرض',
  'createPost.coverUpload': 'انقر لتحميل الغلاف',
  'createPost.coverHint': 'JPG ، PNG ، GIF (الموصى بها: 500x500px)',
  'createPost.coverDescriptionMusic': 'يمثل الغلاف ألبومك أو أغنيتك وسيظهر في المشغل',
  'createPost.coverDescriptionWriting': 'يمثل الغلاف كتابك أو العمل المكتوب وسيظهر في القارئ',
  'createPost.mainFileLabelMusic': 'الملف الرئيسي (الصوت)',
  'createPost.mainFileLabelWriting': 'الملف الرئيسي (الوثيقة)',
  'createPost.mainFileLabelDefault': 'ملفات الوسائط',
  'createPost.takePhoto': 'التقط صورة',
  'createPost.useCamera': 'استخدم الكاميرا',
  'createPost.uploadFile': 'تحميل ملف',
  'createPost.fromGallery': 'من المعرض',
  'createPost.desktopUploadMusic': 'انقر لتحميل الملفات الصوتية',
  'createPost.desktopUploadWriting': 'انقر لتحميل المستندات',
  'createPost.desktopUploadDefault': 'انقر لتحميل الملفات',
  'createPost.desktopUploadTypesDefault': 'الصور، الفيديو، الصوت، PDF، EPUB',
  'createPost.coverPreviewAlt': 'معاينة الغلاف',
  'createPost.tipLabel': 'نصيحة',
  'createPost.tipMusic': 'أضف غلافًا حتى تبدو موسيقاك أكثر احترافية',
  'createPost.tipWriting': 'أضف غلافًا حتى يبدو عملك أكثر احترافية',
  'createPost.tagsLabel': 'العلامات (مفصول الفاصلة)',
  'createPost.tagsPlaceholderMusic': 'موسيقى الروك، الآلات الموسيقية، الجيتار، اللحني',
  'createPost.tagsPlaceholderWriting': 'الخيال ، الرومانسية ، الخيال ، الرواية',
  'createPost.tagsPlaceholderDefault': 'الفن ، الحديث ، التجريدي ، ملون',
  'createPost.forSaleLabel': 'هذه القطعة للبيع',
  'createPost.priceLabel': 'السعر (يورو)',
  'createPost.pricePlaceholder': '0.00',
  'createPost.cancel': 'يلغي',
  'createPost.publishing': 'نشر...',
  'createPost.publish': 'نشر',
  'auth.validation.emailRequired': 'البريد الإلكتروني مطلوب',
  'auth.validation.emailInvalid': 'بريد إلكتروني غير صالح',
  'auth.validation.passwordRequired': 'كلمة المرور مطلوبة',
  'auth.validation.passwordLength': 'ما لا يقل عن 6 أحرف',
  'auth.validation.usernameRequired': 'اسم المستخدم مطلوب',
  'auth.validation.usernameLength': '3 أحرف على الأقل',
  'auth.validation.fullNameRequired': 'مطلوب الاسم الكامل',
  'auth.validation.birthDateRequired': 'تاريخ الميلاد مطلوب',
  'auth.errors.popupBlocked': 'يرجى السماح للنوافذ المنبثقة بالاستمرار في المصادقة',
  'auth.errors.userCancelled': 'المصادقة التي ألغتها المستخدم',
  'auth.errors.socialAuthPrefix': 'خطأ المصادقة مع',
  'auth.errors.emailExists': 'عنوان البريد الإلكترونى هذا مسجل بالفعل. يرجى تسجيل الدخول أو استخدام بريد إلكتروني آخر.',
  'auth.errors.generic': 'خطأ في المصادقة. يرجى التحقق من بيانات الاعتماد الخاصة بك.',
  'auth.reset.success': 'لقد أرسلنا رابط استرداد إلى بريدك الإلكتروني',
  'auth.reset.title': 'إعادة تعيين كلمة المرور',
  'auth.reset.subtitle': 'سوف نرسل لك رابطا لإعادة تعيين كلمة المرور الخاصة بك',
  'auth.reset.sending': 'إرسال...',
  'auth.reset.submit': 'إرسال رابط الاسترداد',
  'auth.reset.backToLogin': '← العودة لتسجيل الدخول',
  'auth.reset.error': 'خطأ في إرسال البريد الإلكتروني',
  'auth.emailLabel': 'عنوان البريد الإلكتروني',
  'auth.emailPlaceholder': 'you@email.com',
  'auth.hero.tagline': 'المنصة النهائية حيث ينبض الفن بالحياة ويتواصل الفنانون مع العالم',
  'auth.hero.benefit1': 'تواصل مع فنانين عالميين',
  'auth.hero.benefit2': 'بيع وشراء الفن الأصلي',
  'auth.hero.benefit3': 'التعاون في مشاريع فريدة',
  'auth.hero.benefit4': 'اعرض موهبتك للعالم',
  'auth.loginTitle': 'مرحباً',
  'auth.registerTitle': 'إنشاء حساب',
  'auth.loginSubtitle': 'الوصول إلى حساب الفنان الخاص بك',
  'auth.registerSubtitle': 'انضم إلى المجتمع الإبداعي',
  'auth.social.google': 'تابع مع Google',
  'auth.social.apple': 'تواصل مع Apple',
  'auth.social.orEmail': 'أو متابعة البريد الإلكتروني',
  'auth.fullNameLabel': 'الاسم الكامل',
  'auth.fullNamePlaceholder': 'اسمك الكامل',
  'auth.usernameLabel': 'اسم المستخدم',
  'auth.usernamePlaceholder': 'اسم المستخدم',
  'auth.usernameHint': 'فقط الحروف والأرقام والشرطات السفلية. لا @ في البداية.',
  'auth.birthDateLabel': 'تاريخ الميلاد',
  'auth.userTypeLabel': 'نوع الحساب',
  'auth.userType.visitor': 'زائر',
  'auth.userType.visitorHelp': 'استكشف واكتشاف الفن',
  'auth.userType.artist': 'فنان',
  'auth.userType.artistHelp': 'إنشاء وبيع الفن',
  'auth.specialtiesLabel': 'تخصصات فنية',
  'auth.specialtiesHelper': 'حدد الفئات التي تمثل الفن الخاص بك على أفضل وجه',
  'auth.passwordLabel': 'كلمة المرور',
  'auth.passwordHint': 'ما لا يقل عن 6 أحرف',
  'auth.loading.login': 'تسجيل الدخول...',
  'auth.loading.register': 'إنشاء حساب ...',
  'auth.submit.login': 'تسجيل الدخول',
  'auth.submit.register': 'إنشاء حساب',
  'auth.toggle.toRegister': 'ليس لديك حساب؟ إنشاء واحدة جديدة',
  'auth.toggle.toLogin': 'هل لديك بالفعل حساب؟ تسجيل الدخول',
  'auth.forgotPasswordLink': 'نسيت كلمة السر؟',
  'auth.trust.secureData': 'البيانات المضمونة',
  'auth.trust.ssl': 'طبقة المقابس الآمنة المشفرة',
  'auth.trust.gdpr': 'متوافقة مع اللائحة العامة لحماية البيانات',
  'privacy.export.title': 'قم بتنزيل بياناتك',
  'privacy.export.description': 'احصل على نسخة كاملة من نشاطك ومشترياتك وشرائك على SoArtistic.',
  'privacy.export.button': 'قم بتنزيل بياناتي',
  'privacy.export.progress': 'إعداد التنزيل ...',
  'privacy.export.success': 'بدأ التنزيل. تحقق من مجلد التنزيلات الخاص بك.',
  'privacy.export.error': 'غير قادر على تنزيل البيانات الخاصة بك.',
  'privacy.delete.title': 'حذف الحساب',
  'privacy.delete.description': 'يؤدي هذا الإجراء إلى إزالة حسابك وجميع البيانات المرتبطة به نهائيًا.',
  'privacy.delete.warning': 'لا يمكن التراجع عن الحذف وسيتم تسجيل خروجك تلقائيًا.',
  'privacy.delete.confirmLabel': 'اكتب بريدك الإلكتروني للتأكيد',
  'privacy.delete.confirmPlaceholder': 'you@email.com',
  'privacy.delete.button': 'حذف حسابي بشكل دائم',
  'privacy.delete.progress': 'جارٍ حذف الحساب...',
  'privacy.delete.success': 'تم حذف حسابك بنجاح.',
  'privacy.delete.confirmError': 'أدخل بريدك الإلكتروني لتأكيد الحذف.',
  'privacy.delete.error': 'لم نتمكن من حذف حسابك.',
};

export const translations: Record<Language, Record<string, string>> = {
  es: spanish,
  en: english,
  fr: french,
  it: italian,
  pt: portuguese,
  de: german,
  ar: arabic,
};


export const FALLBACK_LANGUAGE: Language = 'es';
export const SUPPORTED_LANGUAGES: Language[] = ['es', 'en', 'fr', 'it', 'pt', 'de', 'ar'];
export const LANGUAGE_LOCALE_MAP: Record<Language, string> = {
  es: 'es-ES',
  en: 'en-US',
  fr: 'fr-FR',
  it: 'it-IT',
  pt: 'pt-PT',
  de: 'de-DE',
  ar: 'ar-SA',
};

const normalizeValue = (value?: string): string => (value ?? '').trim().toLowerCase();

const buildTranslationKeyIndex = (): Record<string, string[]> => {
  const index: Record<string, string[]> = {};

  Object.entries(translations.en ?? {}).forEach(([key, englishValue]) => {
    const normalizedEn = normalizeValue(englishValue);
    if (!normalizedEn) {
      return;
    }

    if (!index[normalizedEn]) {
      index[normalizedEn] = [];
    }
    index[normalizedEn].push(key);

    SUPPORTED_LANGUAGES.forEach((lang) => {
      const localizedValue = translations[lang]?.[key];
      if (!localizedValue) {
        return;
      }

      const normalizedLocalized = normalizeValue(localizedValue);
      if (!normalizedLocalized) {
        return;
      }

      const compositeKey = `${normalizedEn}||${lang}:${normalizedLocalized}`;
      index[compositeKey] = [key];
    });
  });

  return index;
};

export const TRANSLATION_KEY_INDEX = buildTranslationKeyIndex();
